import { PreviewPdf, PreviewFileNamePdf, showToast, PreviewAndDownloadPdf } from "../../../../utils/helper/helper";
import { getPharmacyAccountabilitySettings } from "../../../actions/auth/userProfileActions";

import { currentDate, formatDateToYYYYMMDD_CA } from "../../../../utils/constants/formInitialStates";
import { authToken } from "../../../../storage/authToken";
import { toast } from "react-toastify";

import Axios from "../../../../networking/intraceptor";
import { confirmSendFax } from "../../../../utils/helper/faxConfirmation";
import axios from "axios";
import * as endPoints from '../../../../networking/urlEndPoints';

// Helper function to generate action types with REQUEST, SUCCESS, and FAILURE
// This function takes a base string and returns an object with three properties: REQUEST, SUCCESS, and FAILURE, each suffixed to the base string.
const createActionTypes = (base) => ({
    REQUEST: `${base}_REQUEST`,
    SUCCESS: `${base}_SUCCESS`,
    FAILURE: `${base}_FAILURE`
});

// Action Types
export const actionTypes = {
    FETCH_PATIENT_LIST: createActionTypes('FETCH_PATIENT_LIST'),
    PHARMACARE_PATIENT_SEARCH: createActionTypes('PHARMACARE_PATIENT_SEARCH'),
    PHARMACARE_STORE_PAYMENT: createActionTypes('PHARMACARE_STORE_PAYMENT'),
    PHARMACARE_ADD_RECEIVED_AMOUNT: createActionTypes('PHARMACARE_ADD_RECEIVED_AMOUNT'),
    PHARMACARE_DEDUCTIBLE_LIST: createActionTypes('PHARMACARE_DEDUCTIBLE_LIST'),
    PHARMACARE_DEDUCTIBLE_HISTORY: createActionTypes('PHARMACARE_DEDUCTIBLE_HISTORY'),
    ADD_PATIENT_RX_DETAIL: createActionTypes('ADD_PATIENT_RX_DETAIL'),
    FETCH_RX_ACCOUNTABILITY_PDF: createActionTypes('FETCH_RX_ACCOUNTABILITY_PDF'),
    UPDATE_CONSULTATION: createActionTypes('UPDATE_CONSULTATION'),
    TODAY_PROCESSED_ROUTES: createActionTypes('TODAY_PROCESSED_ROUTES'),
    PREPARE_CHECK: createActionTypes('PREPARE_CHECK'),
    PREP_CHECK_PATIENT_PRESCRIPTION: createActionTypes('PREP_CHECK_PATIENT_PRESCRIPTION'),
    ASSIGN_DIN_LOT: createActionTypes('ASSIGN_DIN_LOT'),
    PREP_CHECK_PREPARE_ALL: createActionTypes('PREP_CHECK_PREPARE_ALL'),
    FETCH_PICK_ROUTE_LOGS: createActionTypes('FETCH_PICK_ROUTE_LOGS'),
    PICKUP_SINGLE_ROUTE: createActionTypes('PICKUP_SINGLE_ROUTE'),
    FINAL_CHECK_LOAD_PATIENTS: createActionTypes('FINAL_CHECK_LOAD_PATIENTS'),
    FINAL_CHECK_ROUTE_LIST: createActionTypes('FINAL_CHECK_ROUTE_LIST'),
    FINAL_CHECK_PATIENT_PRESCRIPTION: createActionTypes('FINAL_CHECK_PATIENT_PRESCRIPTION'),
    TODAY_MISSED_RX_ROUTE_LIST: createActionTypes('TODAY_MISSED_RX_ROUTE_LIST'),
    TODAY_MISSED_RX_ROUTE_LIST_DETAILS: createActionTypes('TODAY_MISSED_RX_ROUTE_LIST_DETAILS'),
    AFTER_PROCESS_PREP_ROUTE_LIST: createActionTypes('AFTER_PROCESS_PREP_ROUTE_LIST'),
    AFTER_PROCESS_PREP_ROUTE_RX_DATA: createActionTypes('AFTER_PROCESS_PREP_ROUTE_RX_DATA'),
    DELIVERY_DRIVER_LIST: createActionTypes('DELIVERY_DRIVER_LIST'),
    SAVE_PATIENT_FLEXI_DELIVERY: createActionTypes('SAVE_PATIENT_FLEXI_DELIVERY'),
    PREP_BUT_NOT_BILLED: createActionTypes('PREP_BUT_NOT_BILLED'),
    FLEXI_DELIVER: createActionTypes('FLEXI_DELIVER'),
    PATIENT_PAYMENT_COLLECTION_LIST: createActionTypes('PATIENT_PAYMENT_COLLECTION_LIST'),
    COPAY_DELIVERIES: createActionTypes('COPAY_DELIVERIES'),
    BILLED_BUT_NOT_PREPARED: createActionTypes('BILLED_BUT_NOT_PREPARED'),
    WRONG_PREP: createActionTypes('WRONG_PREP'),
    DROP_ACTIVE_ROUTE: createActionTypes('DROP_ACTIVE_ROUTE'),
    NOT_BILLED_PREP_WRONG_COUNT: createActionTypes('NOT_BILLED_PREP_WRONG_COUNT'),
    DRUG_INFORMATION_SHEET: createActionTypes('DRUG_INFORMATION_SHEET'),
    GET_MISSED_RX_DATA: createActionTypes('GET_MISSED_RX_DATA'),
    PRINT_LABELS: createActionTypes('PRINT_LABELS'),
    SEARCH_PHARMACY_RX: createActionTypes('SEARCH_PHARMACY_RX'),
    FETCH_DAILY_ROUTINE_TEMPLATE: createActionTypes('FETCH_DAILY_ROUTINE_TEMPLATE'),
    FETCH_SHARED_DAILY_ROUTINE_AVAILABILITY: createActionTypes('FETCH_SHARED_DAILY_ROUTINE_AVAILABILITY'),
    FETCH_SHARED_DAILY_ROUTINE_TEMPLATES: createActionTypes('FETCH_SHARED_DAILY_ROUTINE_TEMPLATES'),
    FETCH_SHARED_DAILY_ROUTINE_TEMPLATE: createActionTypes('FETCH_SHARED_DAILY_ROUTINE_TEMPLATE'),
    IMPORT_SHARED_DAILY_ROUTINE_TEMPLATE: createActionTypes('IMPORT_SHARED_DAILY_ROUTINE_TEMPLATE'),
    LOOKUP_DAILY_ROUTINE_TEMPLATE_ITEM: createActionTypes('LOOKUP_DAILY_ROUTINE_TEMPLATE_ITEM'),
    CREATE_DAILY_ROUTINE_TEMPLATE_ITEM: createActionTypes('CREATE_DAILY_ROUTINE_TEMPLATE_ITEM'),
    UPDATE_DAILY_ROUTINE_TEMPLATE_ITEM: createActionTypes('UPDATE_DAILY_ROUTINE_TEMPLATE_ITEM'),
    DELETE_DAILY_ROUTINE_TEMPLATE_ITEM: createActionTypes('DELETE_DAILY_ROUTINE_TEMPLATE_ITEM'),
    REORDER_DAILY_ROUTINE_TEMPLATE_ITEMS: createActionTypes('REORDER_DAILY_ROUTINE_TEMPLATE_ITEMS'),
    FETCH_DAILY_ROUTINE_TODAY: createActionTypes('FETCH_DAILY_ROUTINE_TODAY'),
    TOGGLE_DAILY_ROUTINE_RUN_ITEM: createActionTypes('TOGGLE_DAILY_ROUTINE_RUN_ITEM'),
    PHARMACY_ACCOUNTABILITY_REPORT: createActionTypes('PHARMACY_ACCOUNTABILITY_REPORT'),
    REPORT_ROUTE_LIST: createActionTypes('REPORT_ROUTE_LIST'),
    DOWNLOAD_REPORT: createActionTypes('DOWNLOAD_REPORT'),
    CHANGE_DOSE: createActionTypes('CHANGE_DOSE'),
    EMERGENCY_REPORT: createActionTypes('EMERGENCY_REPORT'),
    DOWNLOAD_EMERGENCY_REPORT: createActionTypes('DOWNLOAD_EMERGENCY_REPORT'),
    FORCE_DROP_ROUTE: createActionTypes('FORCE_DROP_ROUTE'),
    NOT_BILLED_COUNT: createActionTypes('NOT_BILLED_COUNT'),
    WRONG_PREP_COUNT: createActionTypes('WRONG_PREP_COUNT'),
    BILLED_BUT_NOT_PREPARED_COUNT: createActionTypes('BILLED_BUT_NOT_PREPARED_COUNT'),
    MISSED_3X_COUNT: createActionTypes('MISSED_3X_COUNT'),
    MISSED_4X_COUNT: createActionTypes('MISSED_4X_COUNT'),
    MUTE_RX: createActionTypes('MUTE_RX'),
    DOWNLOAD_BULK_LABEL: createActionTypes('DOWNLOAD_BULK_LABEL'),
    ODD_BILLING: createActionTypes('ODD_BILLING'),
    PATIENT_DRUG_INFORMATION_SHEET: createActionTypes('PATIENT_DRUG_INFORMATION_SHEET'),
    DOWNLOAD_PATIENT_DRUG_INFORMATION_SHEET: createActionTypes('DOWNLOAD_PATIENT_DRUG_INFORMATION_SHEET'),
    EMERGENCY_TODAY_DATA: createActionTypes('EMERGENCY_TODAY_DATA'),
    FETCH_DWI_COUNT: createActionTypes('FETCH_DWI_COUNT'),
    FUTURE_CHANGING_DOSE: createActionTypes('FUTURE_CHANGING_DOSE'),
    WEEKLY_ODD_BILLING_SCHEDULE: createActionTypes('WEEKLY_ODD_BILLING_SCHEDULE'),
    PREP_FOR_NEW_RX_ROUTE_LIST: createActionTypes('PREP_FOR_NEW_RX_ROUTE_LIST'),
    PREP_FOR_NEW_RX_ROUTE_DATA: createActionTypes('PREP_FOR_NEW_RX_ROUTE_DATA'),
    PREP_FOR_NEW_RX_CHECK: createActionTypes('PREP_FOR_NEW_RX_CHECK'),
    FETCH_ODD_SCHEDULE_DYNAMIC_RX: createActionTypes('FETCH_ODD_SCHEDULE_DYNAMIC_RX'),
    FETCH_OTHER_FREQUENCY_DATA: createActionTypes('FETCH_OTHER_FREQUENCY_DATA'),
    FETCH_DILAUDID_DATA: createActionTypes('FETCH_DILAUDID_DATA'),
    FETCH_DILAUDID_SAME_BID: createActionTypes('FETCH_DILAUDID_SAME_BID'),
    FETCH_DILAUDID_DIFFERENT_BID: createActionTypes('FETCH_DILAUDID_DIFFERENT_BID'),
    FETCH_DILAUDID_OTHERS: createActionTypes('FETCH_DILAUDID_OTHERS'),
    FETCH_NON_SAFE_SUPPLY_MISSED_DOSES: createActionTypes('FETCH_NON_SAFE_SUPPLY_MISSED_DOSES'),
    UPDATE_PACMED_TIME: createActionTypes('UPDATE_PACMED_TIME'),
    FETCH_RX_DOSES_NOT_GENERATED: createActionTypes('FETCH_RX_DOSES_NOT_GENERATED'),
    FETCH_DILAUDID_RX_TODAY_PDF: createActionTypes('FETCH_DILAUDID_RX_TODAY_PDF'),
    FETCH_PREVIOUS_DILAUDID_PDF: createActionTypes('FETCH_PREVIOUS_DILAUDID_PDF'),
    FETCH_DO_NOT_BILL: createActionTypes('FETCH_DO_NOT_BILL'),
    FETCH_DILAUDID_FAX_TO_DOCTOR: createActionTypes('FETCH_DILAUDID_FAX_TO_DOCTOR'),
    FETCH_ARV_RX: createActionTypes('FETCH_ARV_RX'),
    PREVIEW_ARV_RX_DATA_FOR_FAX: createActionTypes('PREVIEW_ARV_RX_DATA_FOR_FAX'),
    FETCH_ARV_RX_FAX_LIST: createActionTypes('FETCH_ARV_RX_FAX_LIST'),
    ARV_RX_FAX_VIEW_PDF: createActionTypes('ARV_RX_FAX_VIEW_PDF'),
    FETCH_REFILLS_REQUEST: createActionTypes('FETCH_REFILLS_REQUEST'),
    FETCH_DRUG_FAMILY_LIST: createActionTypes('FETCH_DRUG_FAMILY_LIST'),
    FETCH_DRUG_LIST: createActionTypes('FETCH_DRUG_LIST'),
    GENERATE_FAX_PDF: createActionTypes('GENERATE_FAX_PDF'),
    FETCH_SCHEDULE_RX: createActionTypes('FETCH_SCHEDULE_RX'),
    FETCH_DRUG_FAMILY_LIST_PATIENT: createActionTypes('FETCH_DRUG_FAMILY_LIST_PATIENT'),
    FETCH_DRUG_FAMILY_LIST_ANALYTICS: createActionTypes('FETCH_DRUG_FAMILY_LIST_ANALYTICS'),
    FETCH_PATIENT_LIST_V1: createActionTypes('FETCH_PATIENT_LIST_V1'),
    FETCH_DRUG_VISUAL_INTAKE_MISSING_DINS: createActionTypes('FETCH_DRUG_VISUAL_INTAKE_MISSING_DINS'),
    SAVE_DRUG_VISUAL_INTAKE: createActionTypes('SAVE_DRUG_VISUAL_INTAKE'),
    MISSING_WITNESS_CARRY_RX: createActionTypes('MISSING_WITNESS_CARRY_RX'),
    FETCH_NEW_RX_LIST: createActionTypes('FETCH_NEW_RX_LIST'),
    FETCH_NARCOTIC_RX_BY_DATE: createActionTypes('FETCH_NARCOTIC_RX_BY_DATE'),
    INVENTORY_ACCOUNTABILITY_DISTRIBUTORS: createActionTypes('INVENTORY_ACCOUNTABILITY_DISTRIBUTORS'),
    INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_SAVE: createActionTypes('INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_SAVE'),
    INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_DELETE: createActionTypes('INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_DELETE'),
    INVENTORY_ACCOUNTABILITY_WINRX_COMPARISON: createActionTypes('INVENTORY_ACCOUNTABILITY_WINRX_COMPARISON'),
    INVENTORY_ACCOUNTABILITY_SETUP_STATUS: createActionTypes('INVENTORY_ACCOUNTABILITY_SETUP_STATUS'),
    INVENTORY_ACCOUNTABILITY_SETUP_IMPORT: createActionTypes('INVENTORY_ACCOUNTABILITY_SETUP_IMPORT'),
    INVENTORY_ACCOUNTABILITY_DASHBOARD: createActionTypes('INVENTORY_ACCOUNTABILITY_DASHBOARD'),
    INVENTORY_ACCOUNTABILITY_DOSE_DETAILS: createActionTypes('INVENTORY_ACCOUNTABILITY_DOSE_DETAILS'),
    INVENTORY_ACCOUNTABILITY_DRUG_MOVEMENTS: createActionTypes('INVENTORY_ACCOUNTABILITY_DRUG_MOVEMENTS'),
    INVENTORY_ACCOUNTABILITY_REPORTS: createActionTypes('INVENTORY_ACCOUNTABILITY_REPORTS'),
    INVENTORY_ACCOUNTABILITY_REPORT_PDF: createActionTypes('INVENTORY_ACCOUNTABILITY_REPORT_PDF'),
    INVENTORY_ACCOUNTABILITY_REPORT_CSV: createActionTypes('INVENTORY_ACCOUNTABILITY_REPORT_CSV'),
    INVENTORY_ACCOUNTABILITY_THRESHOLD: createActionTypes('INVENTORY_ACCOUNTABILITY_THRESHOLD'),
    INVENTORY_ACCOUNTABILITY_DRUG_LOTS: createActionTypes('INVENTORY_ACCOUNTABILITY_DRUG_LOTS'),
    INVENTORY_ACCOUNTABILITY_LOTS_ASSIGN: createActionTypes('INVENTORY_ACCOUNTABILITY_LOTS_ASSIGN'),
    INVENTORY_ACCOUNTABILITY_ADJUSTMENT_SAVE: createActionTypes('INVENTORY_ACCOUNTABILITY_ADJUSTMENT_SAVE'),
    INVENTORY_ACCOUNTABILITY_RETURNS_QUEUE: createActionTypes('INVENTORY_ACCOUNTABILITY_RETURNS_QUEUE'),
    INVENTORY_ACCOUNTABILITY_RETURN_RESTOCK: createActionTypes('INVENTORY_ACCOUNTABILITY_RETURN_RESTOCK'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_LIST: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_LIST'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_CREATE: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_CREATE'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_DETAIL: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_DETAIL'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_ADD: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_ADD'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_REMOVE: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_REMOVE'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_CANCEL: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_CANCEL'),
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_COMPLETE: createActionTypes('INVENTORY_ACCOUNTABILITY_DESTRUCTION_COMPLETE'),
    INVENTORY_ACCOUNTABILITY_COUNT_SESSIONS: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNT_SESSIONS'),
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CREATE: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CREATE'),
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_DETAIL: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNT_SESSION_DETAIL'),
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_LINE: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNT_SESSION_LINE'),
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_SIGN: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNT_SESSION_SIGN'),
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CANCEL: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CANCEL'),
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURNS: createActionTypes('INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURNS'),
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREATE: createActionTypes('INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREATE'),
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_SHIP: createActionTypes('INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_SHIP'),
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREDIT: createActionTypes('INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREDIT'),
    INVENTORY_ACCOUNTABILITY_RECALLS: createActionTypes('INVENTORY_ACCOUNTABILITY_RECALLS'),
    INVENTORY_ACCOUNTABILITY_RECALL_CREATE: createActionTypes('INVENTORY_ACCOUNTABILITY_RECALL_CREATE'),
    INVENTORY_ACCOUNTABILITY_RECALL_DETAIL: createActionTypes('INVENTORY_ACCOUNTABILITY_RECALL_DETAIL'),
    INVENTORY_ACCOUNTABILITY_RECALL_CLOSE: createActionTypes('INVENTORY_ACCOUNTABILITY_RECALL_CLOSE'),
    HEALTH_CANADA_RECALLS: createActionTypes('HEALTH_CANADA_RECALLS'),
    INVENTORY_ACCOUNTABILITY_LOT_LOCATION: createActionTypes('INVENTORY_ACCOUNTABILITY_LOT_LOCATION'),
    INVENTORY_ACCOUNTABILITY_SYNC_STATUS: createActionTypes('INVENTORY_ACCOUNTABILITY_SYNC_STATUS'),
    INVENTORY_ACCOUNTABILITY_DRUG_SEARCH: createActionTypes('INVENTORY_ACCOUNTABILITY_DRUG_SEARCH'),
    INVENTORY_ACCOUNTABILITY_COUNTS: createActionTypes('INVENTORY_ACCOUNTABILITY_COUNTS'),
    INVENTORY_ACCOUNTABILITY_DISCREPANCY_RESOLVE: createActionTypes('INVENTORY_ACCOUNTABILITY_DISCREPANCY_RESOLVE'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_LIST: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_LIST'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_LINES: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_LINES'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT_STATUS: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT_STATUS'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_SAVE: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_SAVE'),
    INVENTORY_ACCOUNTABILITY_CATALOG_REFRESH: createActionTypes('INVENTORY_ACCOUNTABILITY_CATALOG_REFRESH'),
    INVENTORY_ACCOUNTABILITY_CATALOG_STATUS: createActionTypes('INVENTORY_ACCOUNTABILITY_CATALOG_STATUS'),
    INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCES: createActionTypes('INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCES'),
    INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCE_SAVE: createActionTypes('INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCE_SAVE'),
    INVENTORY_ACCOUNTABILITY_LINE_MATCH: createActionTypes('INVENTORY_ACCOUNTABILITY_LINE_MATCH'),
    INVENTORY_ACCOUNTABILITY_LINE_NOT_STOCKED: createActionTypes('INVENTORY_ACCOUNTABILITY_LINE_NOT_STOCKED'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_VERIFY: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_VERIFY'),
    INVENTORY_ACCOUNTABILITY_RECEIVING_POST: createActionTypes('INVENTORY_ACCOUNTABILITY_RECEIVING_POST'),
    INVENTORY_ACCOUNTABILITY_PHYSICAL_COUNT: createActionTypes('INVENTORY_ACCOUNTABILITY_PHYSICAL_COUNT'),
    FETCH_DRUG_QUANTITY_BY_DATE: createActionTypes('FETCH_DRUG_QUANTITY_BY_DATE')
};

// Action Creators
// This function creates an action object with a given type and optional payload.
export const createAction = (type, payload = {}) => ({ type, payload });

let prepareCheckAbortControllers = []
let pharmacarePatientSearchAbortControllers = []

// Fetches the pick route logs based on the provided parameters and dispatches the appropriate actions based on the API response.
export const FetchPickRouteLogs = ({ fetchType, pageNumber = 1, date, route, user_type } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_PICK_ROUTE_LOGS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const params = {
            page: pageNumber,
            no_of_records: 10,
            ...(date && { search_date: date }),
            ...(route && { route }),
            ...(user_type && { user_type }),
        };

        const { status, data } = await Axios.get(`${endPoints.accountability_pickup_log}`, { params });

        if (status === 200) {
            const logsData = data?.data?.data || [];
            const pendingRoutes = data?.data?.pending_routes || [];
            const paginationData = data?.data?.pagination || {
                last_page: 1,
                current_page: 1
            };

            const saveData = {
                data: logsData,
                pendingRoutes: pendingRoutes,
                paginationData: paginationData
            }
            dispatch(createAction(actionTypes.FETCH_PICK_ROUTE_LOGS.SUCCESS, {
                data: saveData,
                requestType: fetchType
            }));

        }

    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.FETCH_PICK_ROUTE_LOGS.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};

// Fetches the patient list based on the provided parameters and dispatches the appropriate actions based on the API response.
export const FetchPatientList = ({ fetchType, pageNumber, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_PATIENT_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            list_type: payload?.list_type,
            search_date: payload?.search_date,
            search: payload?.search
        }
        if (pageNumber) {
            params.page = pageNumber
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_getPatientList}`, { params });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_PATIENT_LIST.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_PATIENT_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const FetchPatientListV1 = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_PATIENT_LIST_V1.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_getPatientList_v1}`, { params: payload });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_PATIENT_LIST_V1.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));
        }
    }
    catch (error) {
        dispatch(createAction(actionTypes.FETCH_PATIENT_LIST_V1.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Pharmacare Add Payment – patient search by name/PHN (shared accountability pattern)
export const PharmacarePatientSearch = ({ fetchType = 'pharmacarePatientSearch', search }) => async (dispatch) => {

    // Cancel previous in-flight searches
    pharmacarePatientSearchAbortControllers.forEach(controller => controller.abort());
    pharmacarePatientSearchAbortControllers = [];

    const controller = new AbortController();
    pharmacarePatientSearchAbortControllers.push(controller);

    dispatch(createAction(actionTypes.PHARMACARE_PATIENT_SEARCH.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.patientProfile_searchData}`, {
            params: { search },
            signal: controller.signal
        });

        if (status === 200) {
            dispatch(createAction(actionTypes.PHARMACARE_PATIENT_SEARCH.SUCCESS, {
                data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.PHARMACARE_PATIENT_SEARCH.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Clear pharmacare patient search (e.g. after creating record or closing Add Payment modal) so patient details section hides
export const ClearPharmacarePatientSearch = () => (dispatch) => {
  dispatch(createAction(actionTypes.PHARMACARE_PATIENT_SEARCH.SUCCESS, {
    data: null,
    requestType: 'pharmacarePatientSearch',
  }));
};

// Pharmacare Add Payment – create/store payment record
export const PharmacareStorePayment = ({ fetchType = 'pharmacareStorePayment', payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PHARMACARE_STORE_PAYMENT.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(`${endPoints.pharmacy_pharmacare_store_payment}`, payload);
        if (status === 200 || status === 201) {
            dispatch(createAction(actionTypes.PHARMACARE_STORE_PAYMENT.SUCCESS, {
                data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PHARMACARE_STORE_PAYMENT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Pharmacare Add Received Amount – add payment to existing deductible (row action)
export const AddPharmacareReceivedAmount = (payload) => async (dispatch) => {
  dispatch(createAction(actionTypes.PHARMACARE_ADD_RECEIVED_AMOUNT.REQUEST, { requestType: 'pharmacareAddReceivedAmount' }));

  try {
    const { status, data } = await Axios.post(endPoints.pharmacy_pharmacare_add_received_amount, payload);
    if (status === 200 || status === 201) {
      dispatch(createAction(actionTypes.PHARMACARE_ADD_RECEIVED_AMOUNT.SUCCESS, {
        data: data?.data ?? data,
        requestType: 'pharmacareAddReceivedAmount',
      }));
      return { success: true, data: data?.data ?? data };
    }
    return { success: false, error: data?.message || 'Request failed' };
  } catch (error) {
    const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
    dispatch(createAction(actionTypes.PHARMACARE_ADD_RECEIVED_AMOUNT.FAILURE, {
      error: errMsg,
      requestType: 'pharmacareAddReceivedAmount',
    }));
    return { success: false, error: errMsg };
  }
};

// Pharmacare Deductible – fetch list (type: transactions | patient_summary | monthly_summary)
export const FetchPharmacareDeductibleList = ({
  fetchType = 'pharmacareDeductibleList',
  type = 'transactions',
  page = 1,
  search = '',
  facility = '',
  route = '',
  start_date = '',
  end_date = '',
  remaining_to_date_only = false,
}) => async (dispatch) => {
  dispatch(createAction(actionTypes.PHARMACARE_DEDUCTIBLE_LIST.REQUEST, { requestType: fetchType, append: page > 1 }));

  try {
    const params = {
      type,
      page,
      no_of_records: 25,
      ...(search && search.trim() ? { search: search.trim() } : {}),
      ...(facility && facility !== 'All' ? { facility } : {}),
      ...(route && route !== 'All' ? { route } : {}),
      ...(start_date ? { start_date } : {}),
      ...(end_date ? { end_date } : {}),
      ...(remaining_to_date_only ? { remaining_to_date_only: true } : {}),
    };
    const { status, data } = await Axios.get(endPoints.pharmacy_pharmacare_deductible_list, { params });
    if (status === 200) {
      const payloadData = data?.data ?? data;
      dispatch(createAction(actionTypes.PHARMACARE_DEDUCTIBLE_LIST.SUCCESS, {
        data: payloadData,
        requestType: fetchType,
        append: page > 1,
      }));
    }
  } catch (error) {
    dispatch(createAction(actionTypes.PHARMACARE_DEDUCTIBLE_LIST.FAILURE, {
      error: error?.response?.data?.message || error.message || 'Something went wrong',
      requestType: fetchType,
    }));
  }
};

// Pharmacare Deductible – export to Excel (same filters as list, export=true; reuses decode+download logic from packaging monthly invoice)
export const ExportPharmacareDeductibleList = ({
  type = 'transactions',
  search = '',
  facility = '',
  route = '',
  start_date = '',
  end_date = '',
  remaining_to_date_only = false,
  setExportLoading,
}) => async (dispatch) => {
  if (typeof setExportLoading === 'function') setExportLoading(true);
  try {
    const params = {
      type,
      export: true,
      ...(search && search.trim() ? { search: search.trim() } : {}),
      ...(facility && facility !== 'All' ? { facility } : {}),
      ...(route && route !== 'All' ? { route } : {}),
      ...(start_date ? { start_date } : {}),
      ...(end_date ? { end_date } : {}),
      ...(remaining_to_date_only ? { remaining_to_date_only: true } : {}),
    };
    const { status, data } = await Axios.get(endPoints.pharmacy_pharmacare_deductible_list, { params });
    if (status === 200) {
      const payload = data?.data ?? data;
      const base64 = payload?.['invoice excel'] ?? payload?.invoice_excel;
      if (typeof base64 === 'string') {
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'pharmacare-deductible.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => window.URL.revokeObjectURL(fileUrl), 1000);
      } else {
        showToast('Something went wrong while downloading invoice excel', 'error');
      }
    }
  } catch (error) {
    showToast(error?.response?.data?.message || error.message || 'Something went wrong while downloading invoice excel', 'error');
  } finally {
    if (typeof setExportLoading === 'function') setExportLoading(false);
  }
};

// Pharmacare Deductible – delete records by ids (POST { ids: number[] })
export const DeletePharmacareDeductibles = ({ ids }) => async (dispatch) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return { success: false, error: 'No records selected' };
  }
  try {
    const { status, data } = await Axios.post(endPoints.pharmacy_pharmacare_delete_deductibles, { ids });
    if (status === 200 && data?.success) {
      const count = data?.data?.['deleted count'] ?? data?.data?.deleted_count ?? ids.length;
      showToast(data?.message || `Deleted ${count} record(s).`, 'success');
      return { success: true };
    }
    return { success: false, error: data?.message || 'Delete failed' };
  } catch (error) {
    const msg = error?.response?.data?.message || error.message || 'Failed to delete records';
    showToast(msg, 'error');
    return { success: false, error: msg };
  }
};

// Pharmacare Deductible History – fetch by deductible id for history sheet
export const FetchPharmacareDeductibleHistory = (deductibleId) => async (dispatch) => {
  if (deductibleId == null || deductibleId === '') return;
  dispatch(createAction(actionTypes.PHARMACARE_DEDUCTIBLE_HISTORY.REQUEST, { requestType: 'pharmacareDeductibleHistory' }));

  try {
    const url = endPoints.pharmacy_pharmacare_deductible_history(deductibleId);
    const { status, data } = await Axios.get(url);
    if (status === 200) {
      dispatch(createAction(actionTypes.PHARMACARE_DEDUCTIBLE_HISTORY.SUCCESS, {
        data: data?.data ?? data,
        requestType: 'pharmacareDeductibleHistory',
      }));
    }
  } catch (error) {
    dispatch(createAction(actionTypes.PHARMACARE_DEDUCTIBLE_HISTORY.FAILURE, {
      error: error?.response?.data?.message || error.message || 'Something went wrong',
      requestType: 'pharmacareDeductibleHistory',
    }));
  }
};

// Fetches the details of a patient's prescription based on the provided parameters and dispatches the appropriate actions based on the API response.
let patientRxDetailAbortControllers = []
export const FetchPatientRxDetail = ({ fetchType, payload }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    patientRxDetailAbortControllers.forEach(controller => controller.abort());
    patientRxDetailAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    patientRxDetailAbortControllers.push(controller);

    dispatch(createAction(actionTypes.ADD_PATIENT_RX_DETAIL.REQUEST, {
        requestType: fetchType
    }));
    try {

        const { status, data } = await Axios.get(`${endPoints.accountability_getPatientRxDetail}?p_id=${payload?.patient_id}&list_type=${payload?.list_type}&fdate=${payload?.search_date}`,
            { signal: controller.signal });

        if (status === 200) {
            const patientID = Number(data?.data?.patient_id)
            if (patientID === payload?.patient_id) {
                dispatch(createAction(actionTypes.ADD_PATIENT_RX_DETAIL.SUCCESS, {
                    data: data?.data,
                    requestType: fetchType
                }));
            }
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.ADD_PATIENT_RX_DETAIL.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
};

// Fetches the Rx accountability PDF and previews it, dispatching the appropriate actions based on the API response.
export const FetchRxAccountabilityPdf = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_RX_ACCOUNTABILITY_PDF.REQUEST, {
        requestType: fetchType
    }));
    try {

        const { status, data } = await Axios.post(`${endPoints.accountability_getRxAccountabilityPdf}`, payload);
        if (status === 200) {
            PreviewPdf(data?.data?.pdf)
            dispatch(createAction(actionTypes.FETCH_RX_ACCOUNTABILITY_PDF.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_RX_ACCOUNTABILITY_PDF.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Updates the consultation details and fetches the updated patient Rx details, dispatching the appropriate actions based on the API response.
export const UpdateConsultation = ({ fetchType, payload, formData, selectedId }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_CONSULTATION.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_update_consultation}`, payload);
        if (status === 200) {
            dispatch(FetchPatientRxDetail({
                fetchType: 'addPatientRxDetail',
                payload: {
                    patient_id: selectedId,
                    list_type: formData?.list_type?.value,
                    search_date: formData?.date
                }
            }))
            dispatch(createAction(actionTypes.UPDATE_CONSULTATION.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.UPDATE_CONSULTATION.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches today's processed routes and handles the default pickup route, dispatching the appropriate actions based on the API response.
export const FetchTodayProcessedRoutes = ({ fetchType, date, handleRouteClick }) => async (dispatch) => {
    dispatch(createAction(actionTypes.TODAY_PROCESSED_ROUTES.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_todayProcessedRoutes}?search_date=${date}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.TODAY_PROCESSED_ROUTES.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
            const defaultPickupRoute = data?.data?.picked_route_data?.pickupRoute
            if (defaultPickupRoute && typeof handleRouteClick === 'function') {
                handleRouteClick(defaultPickupRoute)
            }
        }
    } catch (error) {
        dispatch(createAction(actionTypes.TODAY_PROCESSED_ROUTES.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches the prepare check data based on the provided parameters and dispatches the appropriate actions based on the API response.
export const FetchPrepareCheck = ({ fetchType, formData, pickupRoute, page, patientId }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PREPARE_CHECK.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            route: pickupRoute,
            search_date: formData?.date,
            no_of_records: 15
        }
        if (page) {
            params.page = page
        }
        if (patientId) {
            params.patient_id = patientId
        }
        if (formData?.list_type) {
            if (formData?.list_type.value === 'fentanyl') {
                params.is_fentanyl = 1
            } else {
                params.medication_status = formData?.list_type.value
            }
        }

        const { status, data } = await Axios.get(`${endPoints.accountability_prepareCheck}`, { params })
        if (status === 200) {
            dispatch(createAction(actionTypes.PREPARE_CHECK.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PREPARE_CHECK.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}




// Fetches the prepare check patient prescriptions based on the provided parameters and dispatches the appropriate actions based on the API response.

export const FetchPrepareCheckPatientPrescriptions = ({ fetchType,
    patient_id,
    search_date,
    next_number_of_days,
    type,
    medication_status,
    sort_by
}) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    prepareCheckAbortControllers.forEach(controller => controller.abort());
    prepareCheckAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    prepareCheckAbortControllers.push(controller);

    if (type !== 'multidate') {
        dispatch(createAction(actionTypes.PREP_CHECK_PATIENT_PRESCRIPTION.REQUEST, {
            requestType: fetchType
        }));
    }

    try {
        const params = {
            patient_id,
            search_date,
            next_number_of_days,
        };

        if (medication_status === 'new') {
            params.medication_status = 'new'
        }

        if (sort_by) {
            params.sort_by = sort_by
        }

        const { status, data } = await Axios.get(
            `${endPoints.accountability_prepareCheck_patientMedicationList}`,
            { params, signal: controller.signal }
        );

        const patientID = Number(data?.patient_id)

        if (status === 200) {
            if (patientID === patient_id) {
                dispatch(createAction(actionTypes.PREP_CHECK_PATIENT_PRESCRIPTION.SUCCESS, {
                    data,
                    requestType: fetchType
                }));
            }
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }

        dispatch(createAction(actionTypes.PREP_CHECK_PATIENT_PRESCRIPTION.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
};

// Fetches lot number and expiry date per DIN from assign-din-lot API (GET with dins as params); used to prefill Lot/Expiry in prep check.
export const FetchAssignDinLot = ({ dins, fetchType = 'fetchAssignDinLot' }) => async (dispatch) => {
    if (!dins || dins.length === 0) return;
    dispatch(createAction(actionTypes.ASSIGN_DIN_LOT.REQUEST, { requestType: fetchType }));
    try {
        const { status, data } = await Axios.get(endPoints.accountability_assignDinLot, {
            params: { dins },
        });
        if (status === 200 && data?.data) {
            dispatch(createAction(actionTypes.ASSIGN_DIN_LOT.SUCCESS, { data: data.data, requestType: fetchType }));
        } else {
            dispatch(createAction(actionTypes.ASSIGN_DIN_LOT.SUCCESS, { data: [], requestType: fetchType }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ASSIGN_DIN_LOT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Failed to fetch DIN lot data',
            requestType: fetchType
        }));
    }
};

/** First validation / error string from assign-din-lot style payloads */
const assignDinLotErrorMessage = (payload) => {
    if (!payload || typeof payload !== 'object') return null;
    if (typeof payload.message === 'string' && payload.message.trim()) return payload.message.trim();
    const d = payload.data;
    if (d && typeof d === 'object' && !Array.isArray(d)) {
        for (const v of Object.values(d)) {
            if (typeof v === 'string' && v.trim()) return v.trim();
            if (Array.isArray(v) && v.length && typeof v[0] === 'string') return v[0].trim();
        }
    }
    return null;
};

const normalizeDinLotItems = (items = []) => {
    const byDin = new Map();
    if (!Array.isArray(items)) return [];

    items.forEach((item) => {
        const din = item?.din != null ? String(item.din).trim() : '';
        if (!din) return;

        byDin.set(din, {
            din,
            lot_number: item?.lot_number ?? item?.lot ?? '',
            expiry_date: item?.expiry_date ?? item?.expiry ?? '',
            ...(item?.gtin ? { gtin: item.gtin } : {})
        });
    });

    return Array.from(byDin.values());
};

// Saves DIN lot and expiry via POST assign-din-lot (JSON body: din, lot_number, expiry_date).
// Resolves to { ok: true, data } or { ok: false, data?, error? } so callers can update UI only on success.
export const SaveDinLot = ({ din, lot_number, expiry_date, showSuccessToast = true }) => async (dispatch) => {
    if (!din) return { ok: false, error: 'Missing DIN' };
    try {
        const body = {
            din: String(din),
            lot_number: lot_number ?? '',
            expiry_date: expiry_date ?? ''
        };
        const { status, data } = await Axios.post(endPoints.accountability_assignDinLot, body);
        if (status === 200 && data?.success === false) {
            const msg = assignDinLotErrorMessage(data) || 'Failed to save DIN lot.';
            showToast(msg, 'error');
            return { ok: false, data, error: msg };
        }
        if (status === 200) {
            if (showSuccessToast) {
                showToast(data?.message || 'DIN lot saved successfully.', 'success');
            }
            return { ok: true, data };
        }
        showToast('Failed to save DIN lot.', 'error');
        return { ok: false, data };
    } catch (error) {
        const res = error?.response?.data;
        const msg = assignDinLotErrorMessage(res) || res?.message || error.message || 'Failed to save DIN lot.';
        showToast(msg, 'error');
        return { ok: false, error: msg, data: res };
    }
};

// Saves multiple DIN lot/expiry rows in a single request. Duplicate DINs are collapsed to the last edited value.
export const SaveDinLotBulk = ({ items = [], showSuccessToast = true }) => async () => {
    const normalizedItems = normalizeDinLotItems(items);

    if (!normalizedItems.length) {
        return { ok: true, data: [] };
    }

    try {
        const { status, data } = await Axios.post(endPoints.accountability_assignDinLotBulk, {
            items: normalizedItems
        });

        if (status === 200 && data?.success === false) {
            const msg = assignDinLotErrorMessage(data) || 'Failed to save DIN lots.';
            showToast(msg, 'error');
            return { ok: false, data, error: msg };
        }

        if (status === 200) {
            if (showSuccessToast) {
                showToast(data?.message || 'DIN lots saved successfully.', 'success');
            }
            return { ok: true, data: data?.data || [], response: data };
        }

        showToast('Failed to save DIN lots.', 'error');
        return { ok: false, data };
    } catch (error) {
        const res = error?.response?.data;
        const msg = assignDinLotErrorMessage(res) || res?.message || error.message || 'Failed to save DIN lots.';
        showToast(msg, 'error');
        return { ok: false, error: msg, data: res };
    }
};

// Prepares all patients for the prepare check and fetches the updated prepare check data, dispatching the appropriate actions based on the API response.
export const FetchPrepareCheckPrepareAll = ({ payload,
    formData,
    pickupRoute,
    setAllPatients,
    currentPage,
    patientId }) => async (dispatch) => {
        try {
            const { status } = await Axios.post(`${endPoints.accountability_prepareCheck_prepareAll}`, payload)
            if (status === 200) {
                dispatch(FetchPrepareCheck({
                    fetchType: 'fetchPrepareCheck',
                    formData,
                    pickupRoute,
                    setAllPatients,
                    page: currentPage,
                    patientId
                }));
            }
        } catch (error) {
            alert(error?.response?.data?.message || error.message || 'Something went wrong')
        }
    }

// Checks a single pickup route and updates the state based on the API response, dispatching the appropriate actions.
export const CheckPickupSingleRoute = ({ fetchType,
    payload,
    setPickupRoute,
    setAllPatients,
    pickupRoute }) => async (dispatch) => {
        dispatch(createAction(actionTypes.PICKUP_SINGLE_ROUTE.REQUEST, {
            requestType: fetchType
        }));
        try {
            const { status, data } = await Axios.post(`${endPoints.accountability_pickup_single_route}`, payload)
            if (status === 200) {
                dispatch(createAction(actionTypes.PICKUP_SINGLE_ROUTE.SUCCESS, {
                    data: data,
                    requestType: fetchType
                }))
                if (data?.success && data?.message === 'Can pick this route') {
                    setPickupRoute(payload?.route)
                    if (pickupRoute !== payload?.route) {
                        setAllPatients([])
                    }
                } else {
                    setPickupRoute('')
                    setAllPatients([])
                }
            }
        } catch (error) {
            dispatch(createAction(actionTypes.PICKUP_SINGLE_ROUTE.FAILURE, {
                error: error?.response?.data?.message || error.message || 'Something went wrong',
                requestType: fetchType
            }));
        }
    }

// Fetches the final check load patients based on the provided parameters and dispatches the appropriate actions based on the API response.
export const fetchFinalCheckLoadPatients = ({ fetchType, selectedRoute, searchDate, page }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FINAL_CHECK_LOAD_PATIENTS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            route: selectedRoute,
            search_date: searchDate,
            no_of_records: 100
        }
        if (page) {
            params.page = page
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_finalCheck_loadPatients}`, { params })
        if (status === 200) {
            dispatch(createAction(actionTypes.FINAL_CHECK_LOAD_PATIENTS.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FINAL_CHECK_LOAD_PATIENTS.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches the final check route list based on the provided parameters and dispatches the appropriate actions based on the API response.
export const FinalCheckRouteList = ({ fetchType, searchDate }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FINAL_CHECK_ROUTE_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            search_date: searchDate,
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_finalCheck_route_list}`, { params })
        if (status === 200) {
            dispatch(createAction(actionTypes.FINAL_CHECK_ROUTE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FINAL_CHECK_ROUTE_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let finalCheckAbortControllers = []
// Fetches the final check patient prescription based on the provided parameters and dispatches the appropriate actions based on the API response.
export const FinalCheckPatientPrescription = ({ fetchType,
    patientId,
    searchDate,
    type
}) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    finalCheckAbortControllers.forEach(controller => controller.abort());
    finalCheckAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    finalCheckAbortControllers.push(controller);
    if (type !== 'finalCheckMultiDates') {
        dispatch(createAction(actionTypes.FINAL_CHECK_PATIENT_PRESCRIPTION.REQUEST, {
            requestType: fetchType
        }));

    }
    try {
        const params = {
            search_date: searchDate,
            patient_id: patientId
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_finalCheck_patientPrescription}`, {
            params,
            signal: controller.signal
        })
        if (status === 200) {
            const patientID = Number(data?.patient_id)
            if (patientID === patientId) {
                dispatch(createAction(actionTypes.FINAL_CHECK_PATIENT_PRESCRIPTION.SUCCESS, {
                    data: data,
                    requestType: fetchType
                }))
            }
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FINAL_CHECK_PATIENT_PRESCRIPTION.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Prepares all patients for the final check and fetches the updated final check data, dispatching the appropriate actions based on the API response.
export const FinalCheckPrepareAll = ({ payload, formData }) => async (dispatch) => {
    try {
        const { status } = await Axios.post(`${endPoints.accountability_finalCheck_prepareAll}`, payload)
        if (status === 200) {
            dispatch(FinalCheckPatientPrescription({
                patientId: payload?.patient_id,
                searchDate: formData?.date,
                fetchType: 'finalCheckPatientPrescription'
            }))
            dispatch(fetchFinalCheckLoadPatients({
                fetchType: 'fetchFinalCheckLoadPatients',
                selectedRoute: formData?.route,
                searchDate: formData?.date,
                page: 1
            }));
        }
    } catch (error) {
        alert(error?.response?.data?.message || error.message || 'Something went wrong')
    }
}

// Fetches today's missed Rx route list based on the provided parameters and dispatches the appropriate actions based on the API response.
let fetchTodayMissedRxRouteListAbortControllers = []
export const fetchTodayMissedRxRouteList = ({ fetchType, filterType, listType }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    fetchTodayMissedRxRouteListAbortControllers.forEach(controller => controller.abort());
    fetchTodayMissedRxRouteListAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchTodayMissedRxRouteListAbortControllers.push(controller);

    dispatch(createAction(actionTypes.TODAY_MISSED_RX_ROUTE_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_todayMissedRxRouteList}?filter_type=${filterType}&filter_by=${listType}`, { signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.TODAY_MISSED_RX_ROUTE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.TODAY_MISSED_RX_ROUTE_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches after process prep route list and dispatches the appropriate actions based on the API response.
let fetchAfterProcessPrepRouteListAbortControllers = []
export const fetchAfterProcessPrepRouteList = ({ fetchType }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    fetchAfterProcessPrepRouteListAbortControllers.forEach(controller => controller.abort());
    fetchAfterProcessPrepRouteListAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchAfterProcessPrepRouteListAbortControllers.push(controller);

    dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(endPoints.accountability_afterProcessPrepRouteList, { signal: controller.signal });
        if (status === 200) {
            // Transform the response to match the expected format: { success: true, data: ["P3", "W2", ...] }
            // Convert to { routes: ["P3", "W2", ...] } format to match existing structure
            const transformedData = {
                success: data.success,
                routes: data.data || []
            };
            dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_LIST.SUCCESS, {
                data: transformedData,
                requestType: fetchType
            }));
        }

        // if (status === 200) {
        //     const filteredRoutes = (data.data || []).filter(route =>
        //         typeof route === 'string' && /^[A-Z0-9]+$/.test(route)
        //     );
        
        //     const transformedData = {
        //         success: data.success,
        //         routes: filteredRoutes
        //     };
        
        //     dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_LIST.SUCCESS, {
        //         data: transformedData,
        //         requestType: fetchType
        //     }));
        // }


    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches delivery driver list
let fetchDeliveryDriverListAbortControllers = []
export const fetchDeliveryDriverList = ({ fetchType }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    fetchDeliveryDriverListAbortControllers.forEach(controller => controller.abort());
    fetchDeliveryDriverListAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchDeliveryDriverListAbortControllers.push(controller);

    dispatch(createAction(actionTypes.DELIVERY_DRIVER_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(endPoints.accountability_deliveryDriverList, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.DELIVERY_DRIVER_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.DELIVERY_DRIVER_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches after process prep route Rx data based on the provided parameters and dispatches the appropriate actions based on the API response.
let fetchAfterProcessPrepRouteRxDataAbortControllers = []
let fetchAfterProcessPrepRouteRxDataBackgroundAbortControllers = []
export const fetchAfterProcessPrepRouteRxData = ({ fetchType, route, deliveryType, pageNumber, filterType, backgroundFetch = false }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts (only for non-background fetches)
    if (!backgroundFetch) {
        fetchAfterProcessPrepRouteRxDataAbortControllers.forEach(controller => controller.abort());
        fetchAfterProcessPrepRouteRxDataAbortControllers = []; // Clear the array
        // Also cancel background fetches when a new main fetch starts
        fetchAfterProcessPrepRouteRxDataBackgroundAbortControllers.forEach(controller => controller.abort());
        fetchAfterProcessPrepRouteRxDataBackgroundAbortControllers = []; // Clear the array
    }

    // 🆕 Create new controller
    const controller = new AbortController();
    if (backgroundFetch) {
        fetchAfterProcessPrepRouteRxDataBackgroundAbortControllers.push(controller);
    } else {
        fetchAfterProcessPrepRouteRxDataAbortControllers.push(controller);
    }

    // Don't dispatch REQUEST for background fetches to avoid showing loading state
    if (!backgroundFetch) {
        dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_RX_DATA.REQUEST, {
            requestType: fetchType
        }));
    }
    try {
        const params = {
            route: route,
            delivery_type: deliveryType,
            filter_type: filterType,
            no_of_records: 50
        }
        if (pageNumber) {
            params.page = pageNumber
        }
        const { status, data } = await Axios.get(endPoints.accountability_afterProcessPrepRouteRxData, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_RX_DATA.SUCCESS, {
                data: data.data,
                requestType: fetchType,
                append: backgroundFetch, // Flag to indicate if data should be appended
                pageNumber: pageNumber
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        // Don't dispatch FAILURE for background fetches to avoid showing error state
        if (!backgroundFetch) {
            dispatch(createAction(actionTypes.AFTER_PROCESS_PREP_ROUTE_RX_DATA.FAILURE, {
                error: error?.response?.data?.message || error.message || 'Something went wrong',
                requestType: fetchType
            }));
        }
    }
}

// Fetches after process prep route Rx data by IDs
export const fetchAfterProcessPrepRxDataByIds = ({ ids }) => async (dispatch) => {
    if (!ids || !Array.isArray(ids) || ids.length === 0) {
        console.warn('No valid IDs provided for fetchAfterProcessPrepRxDataByIds');
        return null;
    }

    try {
        const idsString = ids.join(',');
        const params = { ids: idsString };
        const { status, data } = await Axios.get(endPoints.accountability_afterProcessPrepRxDataByIds, { params });
        
        if (status === 200 && data?.success && data?.data?.data) {
            return data.data.data; // Return the array of records
        }
        return [];
    } catch (error) {
        console.error('Error fetching Rx data by IDs:', error);
        return [];
    }
}

// Fetches today's missed Rx route list details based on the provided parameters and dispatches the appropriate actions based on the API response.
let fetchTodayMissedRxRouteListDetailsAbortControllers = []
export const fetchTodayMissedRxRouteListDetails = ({ fetchType, route, deliveryType, pageNumber, filterType, type, dateType }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    fetchTodayMissedRxRouteListDetailsAbortControllers.forEach(controller => controller.abort());
    fetchTodayMissedRxRouteListDetailsAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchTodayMissedRxRouteListDetailsAbortControllers.push(controller);
    if (type !== 'todayMissedRx') {
        dispatch(createAction(actionTypes.TODAY_MISSED_RX_ROUTE_LIST_DETAILS.REQUEST, {
            requestType: fetchType
        }));
    }
    try {
        const params = {
            route: route,
            delivery_type: deliveryType,
            filter_type: filterType,
            no_of_records: 500
        }
        if (pageNumber) {
            params.page = pageNumber
        }
        if (dateType) {
            params.date_type = dateType
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_todayMissedRxRouteListDetails}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.TODAY_MISSED_RX_ROUTE_LIST_DETAILS.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.TODAY_MISSED_RX_ROUTE_LIST_DETAILS.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Updates today's prep check and fetches the updated missed Rx route list details, dispatching the appropriate actions based on the API response.
export const UpdateTodayPrepCheck = ({ payload, pageNumber, deliveryType, route, accountabilitySettings, filterType, skipRefetch, dateType }) => async (dispatch) => {
    try {
        const upload_data = {
            update_prep_check: payload,
        }
        const { data } = await Axios.post(`${endPoints.accountability_updateTodayPrepCheck}`, upload_data)
        if (route && accountabilitySettings !== 'preparation' && !skipRefetch) {
            dispatch(fetchTodayMissedRxRouteListDetails({
                fetchType: 'fetchTodayMissedRxRouteListDetails',
                route: route,
                deliveryType: deliveryType,
                pageNumber: pageNumber,
                filterType: filterType,
                dateType: dateType
            }))
        }
        return data
    } catch (error) {
        alert(error?.response?.data?.message || error.message || 'Something went wrong')
    }
}

// Updates individual prep check (sends only the single checked item, not all selected items)
export const UpdateTodayPrepCheckIndividual = ({ payload, pageNumber, deliveryType, route, accountabilitySettings, filterType, skipRefetch, dateType }) => async (dispatch) => {
    try {
        const upload_data = {
            update_prep_check: payload,
        }
        const { data } = await Axios.post(`${endPoints.accountability_updateTodayPrepCheck}`, upload_data)
        if (route && accountabilitySettings !== 'preparation' && !skipRefetch) {
            dispatch(fetchTodayMissedRxRouteListDetails({
                fetchType: 'fetchTodayMissedRxRouteListDetails',
                route: route,
                deliveryType: deliveryType,
                pageNumber: pageNumber,
                filterType: filterType,
                dateType: dateType
            }))
        }
        return data
    } catch (error) {
        alert(error?.response?.data?.message || error.message || 'Something went wrong')
    }
}

// Updates the accountability settings and fetches the updated pharmacy accountability settings, dispatching the appropriate actions based on the API response.
export const UpdateAccountabilitySettings = ({ value }) => async (dispatch) => {
    try {
        const upload_data = {
            finalchk_at: value,
        }
        const { data, status } = await Axios.post(`${endPoints.accountability_updateAccountabilitySettings}`, upload_data)

        if (status === 200) {
            const finalchk_at = data?.data?.finalchk_at
            dispatch(getPharmacyAccountabilitySettings(finalchk_at))
        }
        return data
    } catch (error) {
        alert(error?.response?.data?.message || error.message || 'Something went wrong')
    }
}

// Updates the final check and fetches the updated missed Rx route list details, dispatching the appropriate actions based on the API response.
export const UpdateFinalCheck = ({ deliveryType,
    route,
    payload,
    pageNumber,
    setMasterCheckbox,
    setMasterFinalCheck,
    setSelectedPrescriptions,
    setSelectedFinalCheck,
    filterType,
    skipRefetch,
    dateType }) => async (dispatch) => {
        try {
            const upload_data = {
                update_prep_check: payload,
            }
            const { status, data } = await Axios.post(`${endPoints.accountability_updateFinalCheck}`, upload_data)
            if (status === 200) {
                if (!skipRefetch) {
                    dispatch(fetchTodayMissedRxRouteListDetails({
                        fetchType: 'fetchTodayMissedRxRouteListDetails',
                        route: route,
                        deliveryType: deliveryType,
                        pageNumber: pageNumber,
                        filterType: filterType,
                        dateType: dateType
                    }))
                    // Only reset state when refetching (for other pages)
                    setMasterCheckbox(false)
                    setMasterFinalCheck(false)
                    setSelectedPrescriptions([])
                    setSelectedFinalCheck([])
                }
                // When skipRefetch is true (after-process-prep page), don't reset state
                // This preserves final check stamps when prep check is clicked
            }
            return data
        } catch (error) {
            alert(error?.response?.data?.message || error.message || 'Something went wrong')
        }
    }

// Updates individual final check (sends only the single checked item, not all selected items)
export const UpdateFinalCheckIndividual = ({ deliveryType,
    route,
    payload,
    pageNumber,
    setMasterCheckbox,
    setMasterFinalCheck,
    setSelectedPrescriptions,
    setSelectedFinalCheck,
    filterType,
    skipRefetch,
    dateType }) => async (dispatch) => {
        try {
            const upload_data = {
                update_prep_check: payload,
            }
            const { status, data } = await Axios.post(`${endPoints.accountability_updateFinalCheck}`, upload_data)
            if (status === 200) {
                if (!skipRefetch) {
                    dispatch(fetchTodayMissedRxRouteListDetails({
                        fetchType: 'fetchTodayMissedRxRouteListDetails',
                        route: route,
                        deliveryType: deliveryType,
                        pageNumber: pageNumber,
                        filterType: filterType,
                        dateType: dateType
                    }))
                    // Only reset state when refetching (for other pages)
                    setMasterCheckbox(false)
                    setMasterFinalCheck(false)
                    setSelectedPrescriptions([])
                    setSelectedFinalCheck([])
                }
                // When skipRefetch is true (after-process-prep page), don't reset state
                // This preserves final check stamps when prep check is clicked
            }
            return data
        } catch (error) {
            alert(error?.response?.data?.message || error.message || 'Something went wrong')
        }
    }

// Saves patient flexi delivery/pickup information
export const savePatientFlexiDelivery = ({ payload }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.SAVE_PATIENT_FLEXI_DELIVERY.REQUEST, {
            requestType: 'savePatientFlexiDelivery'
        }));

        const { status, data } = await Axios.post(`${endPoints.accountability_savePatientFlexiDelivery}`, { data: payload });

        if (status === 200) {
            dispatch(createAction(actionTypes.SAVE_PATIENT_FLEXI_DELIVERY.SUCCESS, {
                data: data,
                requestType: 'savePatientFlexiDelivery'
            }));
            return data;
        }
    } catch (error) {
        dispatch(createAction(actionTypes.SAVE_PATIENT_FLEXI_DELIVERY.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: 'savePatientFlexiDelivery'
        }));
        showToast(error?.response?.data?.message || error.message || 'Failed to save delivery information', 'error');
        throw error;
    }
}


// Fetches the list of prescriptions that are prepared but not billed, dispatching the appropriate actions based on the API response.
let fetchPrepButNotBilledAbortControllers = []
export const fetchPrepButNotBilled = ({ fetchType, pageNumber, type = 'route' }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    fetchPrepButNotBilledAbortControllers.forEach(controller => controller.abort());
    fetchPrepButNotBilledAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchPrepButNotBilledAbortControllers.push(controller);

    dispatch(createAction(actionTypes.PREP_BUT_NOT_BILLED.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            page: pageNumber,
            no_of_records: 50,
            type: type // Add type parameter (default: 'route')
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_prepButNotBilled}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.PREP_BUT_NOT_BILLED.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.PREP_BUT_NOT_BILLED.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let fetchFlexiDeliverAbortControllers = []
export const fetchFlexiDeliver = ({ fetchType, pageNumber }) => async (dispatch) => {

    fetchFlexiDeliverAbortControllers.forEach(controller => controller.abort());
    fetchFlexiDeliverAbortControllers = [];

    const controller = new AbortController();
    fetchFlexiDeliverAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FLEXI_DELIVER.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            page: pageNumber,
            no_of_records: 50
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_flexiDeliverList}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.FLEXI_DELIVER.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FLEXI_DELIVER.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let fetchPatientPaymentCollectionAbortControllers = []
export const fetchPatientPaymentCollectionList = ({ date, start_date, end_date }) => async (dispatch) => {
    fetchPatientPaymentCollectionAbortControllers.forEach(controller => controller.abort());
    fetchPatientPaymentCollectionAbortControllers = [];

    const controller = new AbortController();
    fetchPatientPaymentCollectionAbortControllers.push(controller);

    dispatch(createAction(actionTypes.PATIENT_PAYMENT_COLLECTION_LIST.REQUEST, {}));
    try {
        // Normalize to YYYY-MM-DD (Canada/Pacific) so API gets date-only, not UTC ISO
        const startDateStr = start_date ? formatDateToYYYYMMDD_CA(start_date) : '';
        const endDateStr = end_date ? formatDateToYYYYMMDD_CA(end_date) : '';
        const params = {
            ...(date && { date }),
            ...(startDateStr && { start_date: startDateStr }),
            ...(endDateStr && { end_date: endDateStr })
        };
        const { status, data } = await Axios.get(`${endPoints.accountability_patientPaymentCollectionList}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.PATIENT_PAYMENT_COLLECTION_LIST.SUCCESS, {
                data: data
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.PATIENT_PAYMENT_COLLECTION_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong'
        }));
    }
}

let fetchCopayDeliveriesAbortControllers = []
export const fetchCopayDeliveries = ({ fetchType, pageNumber, from_date, search, route }) => async (dispatch) => {

    fetchCopayDeliveriesAbortControllers.forEach(controller => controller.abort());
    fetchCopayDeliveriesAbortControllers = [];

    const controller = new AbortController();
    fetchCopayDeliveriesAbortControllers.push(controller);

    dispatch(createAction(actionTypes.COPAY_DELIVERIES.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            page: pageNumber,
            no_of_records: 50,
            ...(from_date && { from_date }),
            ...(search && { search }),
            ...(route && { route })
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_copayDeliveries}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.COPAY_DELIVERIES.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.COPAY_DELIVERIES.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Acknowledges copay delivery for a specific RX number
export const acknowledgeCopayDelivery = ({ payload, setAcknResponse }) => async (dispatch) => {
	try {
		const response = await Axios.post(`${endPoints.accountability_copayDeliveriesAcknowledge}`, payload);
		
		if (response?.status === 200 && response?.data?.success) {
			const ackData = response?.data?.data || {};
			const updatedEntry = {
				rxnumber: ackData?.rxnumber || payload?.rxnumber,
				patientId: ackData?.patient_id || payload?.patient_id,
				copayAmount: ackData?.recopay || payload?.copay_amount,
				acknowledged: true,
				acknowledgedBy: ackData?.pharmacy_user_name || '',
				acknowledgedAt: ackData?.ack_date_time || '',
				pharmacyUserId: ackData?.pharmacy_user_id,
				pharmacyId: ackData?.pharmacy_id,
				isProcessing: false
			};

			setAcknResponse(prev => {
				const existingIndex = prev.findIndex(item => item.rxnumber === payload?.rxnumber);
				
				if (existingIndex !== -1) {
					const updated = [...prev];
					updated[existingIndex] = updatedEntry;
					return updated;
				} else {
					return [...prev, updatedEntry];
				}
			});
		} else {
			// If API fails, remove the temporary entry
			setAcknResponse(prev => 
				prev.filter(item => item.rxnumber !== payload?.rxnumber)
			);
		}
	} catch (error) {
		console.error('Copay acknowledgment error:', error);
		showToast(error?.response?.data?.message || 'Something went wrong', 'error');
		
		// Remove the temporary entry on error
		setAcknResponse(prev => 
			prev.filter(item => item.rxnumber !== payload?.rxnumber)
		);
	}
};

// Fetches the list of prescriptions that are billed but not prepared, dispatching the appropriate actions based on the API response.
let fetchBilledButNotPreparedAbortControllers = []
export const fetchBilledButNotPrepared = ({ fetchType, pageNumber }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    fetchBilledButNotPreparedAbortControllers.forEach(controller => controller.abort());
    fetchBilledButNotPreparedAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchBilledButNotPreparedAbortControllers.push(controller);

    dispatch(createAction(actionTypes.BILLED_BUT_NOT_PREPARED.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            page: pageNumber,
            no_of_records: 50
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_billedButNotPrepared}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.BILLED_BUT_NOT_PREPARED.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.BILLED_BUT_NOT_PREPARED.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches the list of prescriptions that are wrongly prepared, dispatching the appropriate actions based on the API response.
let fetchWrongPrepAbortControllers = []
export const fetchWrongPrep = ({ fetchType, pageNumber }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    fetchWrongPrepAbortControllers.forEach(controller => controller.abort());
    fetchWrongPrepAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchWrongPrepAbortControllers.push(controller);

    dispatch(createAction(actionTypes.WRONG_PREP.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            page: pageNumber,
            no_of_records: 50
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_wrongPrep}`, { params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.WRONG_PREP.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.WRONG_PREP.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Drops the active route and dispatches the appropriate actions based on the API response.
export const DropActiveRoute = ({ fetchType, params }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DROP_ACTIVE_ROUTE.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_dropActiveRoute}`, params)
        if (status === 200) {
            dispatch(createAction(actionTypes.DROP_ACTIVE_ROUTE.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.DROP_ACTIVE_ROUTE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches the list of prescriptions that are not billed and wrongly prepared, dispatching the appropriate actions based on the API response.
let notBilledPrepWrongCountAbortControllers = []

export const fetchNotBilledPrepWrongCount = ({ fetchType, type }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    notBilledPrepWrongCountAbortControllers.forEach(controller => controller.abort());
    notBilledPrepWrongCountAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    notBilledPrepWrongCountAbortControllers.push(controller);

    if (type !== 'notified') {
        dispatch(createAction(actionTypes.NOT_BILLED_PREP_WRONG_COUNT.REQUEST, {
            requestType: fetchType
        }));
    }
    try {

        const { status, data } = await Axios.get(`${endPoints.accountability_notBilledPrepWrongCount}`,
            { signal: controller.signal })
        if (status === 200) {
            const notBilledCount = data?.data?.not_bill_count
            const wrongPrepCount = data?.data?.wrong_prep_count
            const notPreparedCount = data?.data?.not_prep_count
            const missed3xCount = data?.data?.missed_3x_count
            const missed4xCount = data?.data?.missed_4x_count


            dispatch(createAction(actionTypes.NOT_BILLED_COUNT.SUCCESS, {
                data: notBilledCount,
                requestType: fetchType
            }))

            dispatch(createAction(actionTypes.WRONG_PREP_COUNT.SUCCESS, {
                data: wrongPrepCount,
                requestType: fetchType
            }))

            dispatch(createAction(actionTypes.BILLED_BUT_NOT_PREPARED_COUNT.SUCCESS, {
                data: notPreparedCount,
                requestType: fetchType
            }))

            dispatch(createAction(actionTypes.MISSED_3X_COUNT.SUCCESS, {
                data: missed3xCount,
                requestType: fetchType
            }))

            dispatch(createAction(actionTypes.MISSED_4X_COUNT.SUCCESS, {
                data: missed4xCount,
                requestType: fetchType
            }))

            dispatch(createAction(actionTypes.NOT_BILLED_PREP_WRONG_COUNT.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.NOT_BILLED_PREP_WRONG_COUNT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Updates the multi date selection For Prepare Check.
export const HandleUpdateMultiDateSelection = ({ payload,
    formData,
    pickupRoute,
    setAllPatients,
    currentPage,
    patientId }) => async (dispatch) => {
        try {
            const { data } = await Axios.post(`${endPoints.accountability_updateMultiDateSelection}`, payload)
            dispatch(FetchPrepareCheckPatientPrescriptions({
                patient_id: payload.patient_id,
                search_date: formData.date,
                fetchType: 'patientPrescription',
                next_number_of_days: formData?.next_number_of_days?.value,
                type: 'multidate',
                medication_status: formData?.list_type?.value,
                sort_by: formData?.sort_by?.value
            }))
            dispatch(FetchPrepareCheck({
                fetchType: 'fetchPrepareCheck',
                formData,
                pickupRoute,
                setAllPatients,
                page: currentPage,
                patientId
            }));
            return data
        } catch (error) {
            alert(error?.response?.data?.message || error.response?.message || 'Something went wrong')
        }
    }

// Updates the multi date selection For Final Check.
export const HandleFinalCheckMultiDates = ({ payload,
    formData,
    currentPage }) => async (dispatch) => {
        try {
            const { data } = await Axios.post(`${endPoints.accountability_finalCheckMultiDates}`, payload)
            dispatch(FinalCheckPatientPrescription({
                patientId: payload?.patient_id,
                searchDate: formData.date,
                fetchType: 'finalCheckPatientPrescription',
                type: 'finalCheckMultiDates'
            }))
            dispatch(fetchFinalCheckLoadPatients({
                fetchType: 'fetchFinalCheckLoadPatients',
                selectedRoute: formData?.route,
                searchDate: formData?.date,
                page: currentPage
            }))
            return data
        } catch (error) {
            alert(error?.response?.data?.message ||
                error.response?.message ||
                'Something went wrong')
        }
    }


// Fetches the drug information sheet and displays it in a new tab, dispatching the appropriate actions based on the API response.
export const fetchDrugInformationSheet = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DRUG_INFORMATION_SHEET.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_drugInformationSheet}`, { params: payload })
        if (status === 200) {
            const pdfLink = data?.data?.pdf_content
            PreviewPdf(pdfLink)
            dispatch(createAction(actionTypes.DRUG_INFORMATION_SHEET.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
        dispatch(createAction(actionTypes.DRUG_INFORMATION_SHEET.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches the missed Rx data and displays it in a new tab, dispatching the appropriate actions based on the API response.
let getMissedRxDataAbortControllers = []
export const getMissedRxData = ({ fetchType, payload, type }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    getMissedRxDataAbortControllers.forEach(controller => controller.abort());
    getMissedRxDataAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    getMissedRxDataAbortControllers.push(controller);

    // if (type !== 'updateMissedRx') {
    dispatch(createAction(actionTypes.GET_MISSED_RX_DATA.REQUEST, {
        requestType: fetchType
    }));
    // }
    try {
        const { status, data } = await Axios.get(fetchType === 'getMissedRxData3x4x' ? `${endPoints.team3x4xList}` : `${endPoints.accountability_getMissedRxData}`,
            { params: payload, signal: controller.signal })
        if (status === 200) {

            dispatch(createAction(actionTypes.GET_MISSED_RX_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.GET_MISSED_RX_DATA.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const PrintLabels = ({ payload, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PRINT_LABELS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_printLabels}`, payload)
        if (status === 200) {
            PreviewPdf(data?.data)
            dispatch(createAction(actionTypes.PRINT_LABELS.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PRINT_LABELS.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || 'Something went wrong',
            requestType: fetchType
        }));
        showToast(error?.response?.data?.message || error?.response?.message || 'Something went wrong', 'error')
    }
}

export const GenerateLabelsByRxNumbers = ({ payload, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PRINT_LABELS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_generateLabelsByRxNumbers}`, payload)
        if (status === 200) {
            // Show message if present
            if (data?.data?.message || data?.message) {
                showToast(data?.data?.message || data?.message, 'info')
            }
            
            // Only preview PDF if there's actual PDF data (not just a message)
            if (data?.data && !data?.data?.message) {
                PreviewPdf(data?.data)
            }
            
            dispatch(createAction(actionTypes.PRINT_LABELS.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PRINT_LABELS.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || 'Something went wrong',
            requestType: fetchType
        }));
        showToast(error?.response?.data?.message || error?.response?.message || 'Something went wrong', 'error')
    }
}

export const GenerateLabelsByRxDateRange = ({ payload, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PRINT_LABELS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_generateLabelsByRxDateRange}`, payload)
        if (status === 200) {
            // Show message if present
            if (data?.data?.message || data?.message) {
                showToast(data?.data?.message || data?.message, 'info')
            }
            
            // Only preview PDF if there's actual PDF data (not just a message)
            if (data?.data && !data?.data?.message) {
                PreviewPdf(data?.data)
            }
            
            dispatch(createAction(actionTypes.PRINT_LABELS.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PRINT_LABELS.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || 'Something went wrong',
            requestType: fetchType
        }));
        showToast(error?.response?.data?.message || error?.response?.message || 'Something went wrong', 'error')
    }
}

export const SearchPharmacyRx = ({ search, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.SEARCH_PHARMACY_RX.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_pharmacyRxSearch}`, {
            params: { search }
        })
        if (status === 200) {
            dispatch(createAction(actionTypes.SEARCH_PHARMACY_RX.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.SEARCH_PHARMACY_RX.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const ClearPharmacyRxSearch = () => (dispatch) => {
    dispatch(createAction(actionTypes.SEARCH_PHARMACY_RX.SUCCESS, {
        data: null,
        requestType: 'clear'
    }))
}

export const FetchDailyRoutineTemplate = ({ fetchType = 'daily-routine-template' } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DAILY_ROUTINE_TEMPLATE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineTemplate);

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DAILY_ROUTINE_TEMPLATE.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to fetch daily routine template.');
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DAILY_ROUTINE_TEMPLATE.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const FetchSharedDailyRoutineTemplates = ({ fetchType = 'daily-routine-shared-templates' } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_TEMPLATES.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineSharedTemplates);

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_TEMPLATES.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to fetch shared workflows.');
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_TEMPLATES.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const FetchSharedDailyRoutineAvailability = ({ fetchType = 'daily-routine-shared-availability' } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_AVAILABILITY.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineSharedAvailability);

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_AVAILABILITY.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to fetch shared workflow availability.');
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_AVAILABILITY.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const FetchSharedDailyRoutineTemplate = ({ id, fetchType = 'daily-routine-shared-template' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_TEMPLATE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineSharedTemplate(id));

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_TEMPLATE.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to fetch shared workflow.');
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_SHARED_DAILY_ROUTINE_TEMPLATE.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const ImportSharedDailyRoutineTemplate = ({ id, fetchType = 'daily-routine-shared-template-import' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.IMPORT_SHARED_DAILY_ROUTINE_TEMPLATE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(endPoints.accountability_dailyRoutineSharedTemplateImport(id));

        if (status === 200 || status === 201) {
            dispatch(createAction(actionTypes.IMPORT_SHARED_DAILY_ROUTINE_TEMPLATE.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to import workflow.');
    } catch (error) {
        dispatch(createAction(actionTypes.IMPORT_SHARED_DAILY_ROUTINE_TEMPLATE.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const LookupDailyRoutineTemplateItem = ({ name, fetchType = 'daily-routine-template-lookup' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.LOOKUP_DAILY_ROUTINE_TEMPLATE_ITEM.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineTemplateItemLookup, {
            params: { name }
        });

        if (status === 200) {
            dispatch(createAction(actionTypes.LOOKUP_DAILY_ROUTINE_TEMPLATE_ITEM.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to lookup daily routine template item.');
    } catch (error) {
        dispatch(createAction(actionTypes.LOOKUP_DAILY_ROUTINE_TEMPLATE_ITEM.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const CreateDailyRoutineTemplateItem = ({ payload, fetchType = 'daily-routine-template-create' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.CREATE_DAILY_ROUTINE_TEMPLATE_ITEM.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(endPoints.accountability_dailyRoutineTemplateItems, payload);

        if (status === 200 || status === 201) {
            dispatch(createAction(actionTypes.CREATE_DAILY_ROUTINE_TEMPLATE_ITEM.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to create daily routine template item.');
    } catch (error) {
        dispatch(createAction(actionTypes.CREATE_DAILY_ROUTINE_TEMPLATE_ITEM.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const UpdateDailyRoutineTemplateItem = ({ id, payload, fetchType = 'daily-routine-template-update' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_DAILY_ROUTINE_TEMPLATE_ITEM.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.put(endPoints.accountability_dailyRoutineTemplateItem(id), payload);

        if (status === 200) {
            dispatch(createAction(actionTypes.UPDATE_DAILY_ROUTINE_TEMPLATE_ITEM.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to update daily routine template item.');
    } catch (error) {
        dispatch(createAction(actionTypes.UPDATE_DAILY_ROUTINE_TEMPLATE_ITEM.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const DeleteDailyRoutineTemplateItem = ({ id, fetchType = 'daily-routine-template-delete' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DELETE_DAILY_ROUTINE_TEMPLATE_ITEM.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.delete(endPoints.accountability_dailyRoutineTemplateItem(id));

        if (status === 200 || status === 204) {
            dispatch(createAction(actionTypes.DELETE_DAILY_ROUTINE_TEMPLATE_ITEM.SUCCESS, {
                data: data || { id },
                requestType: fetchType
            }));
            return data || { id };
        }

        throw new Error('Failed to delete daily routine template item.');
    } catch (error) {
        dispatch(createAction(actionTypes.DELETE_DAILY_ROUTINE_TEMPLATE_ITEM.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const ReorderDailyRoutineTemplateItems = ({ itemIds, fetchType = 'daily-routine-template-reorder' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.REORDER_DAILY_ROUTINE_TEMPLATE_ITEMS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(endPoints.accountability_dailyRoutineTemplateItemsReorder, {
            item_ids: itemIds
        });

        if (status === 200) {
            dispatch(createAction(actionTypes.REORDER_DAILY_ROUTINE_TEMPLATE_ITEMS.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to reorder daily routine template items.');
    } catch (error) {
        dispatch(createAction(actionTypes.REORDER_DAILY_ROUTINE_TEMPLATE_ITEMS.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const FetchDailyRoutineToday = ({ fetchType = 'daily-routine-today' } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DAILY_ROUTINE_TODAY.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineToday);

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DAILY_ROUTINE_TODAY.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to fetch daily routine for today.');
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DAILY_ROUTINE_TODAY.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const ToggleDailyRoutineRunItem = ({ id, isCompleted, fetchType = 'daily-routine-toggle' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.TOGGLE_DAILY_ROUTINE_RUN_ITEM.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.patch(endPoints.accountability_dailyRoutineRunItemToggle(id), {
            is_completed: isCompleted
        });

        if (status === 200) {
            dispatch(createAction(actionTypes.TOGGLE_DAILY_ROUTINE_RUN_ITEM.SUCCESS, {
                data,
                requestType: fetchType
            }));
            return data;
        }

        throw new Error('Failed to toggle daily routine item.');
    } catch (error) {
        dispatch(createAction(actionTypes.TOGGLE_DAILY_ROUTINE_RUN_ITEM.FAILURE, {
            error: error?.response?.data?.message || error?.response?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

export const FetchDailyRoutineByDate = ({ date, fetchType = 'daily-routine-by-date' } = {}) => async (dispatch) => {
    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineByDate, { params: { date } });
        if (status === 200) return data;
        throw new Error('Failed to fetch daily routine occurrence.');
    } catch (error) {
        throw error;
    }
}

export const FetchDailyRoutineOverdue = ({ params, fetchType = 'daily-routine-overdue' } = {}) => async (dispatch) => {
    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineOverdue, { params });
        if (status === 200) return data;
        throw new Error('Failed to fetch overdue daily routine occurrences.');
    } catch (error) {
        throw error;
    }
}

export const FetchDailyRoutineHistory = ({ params, fetchType = 'daily-routine-history' } = {}) => async (dispatch) => {
    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineHistory, { params });
        if (status === 200) return data;
        throw new Error('Failed to fetch daily routine history.');
    } catch (error) {
        throw error;
    }
}

export const FetchDailyRoutineStaff = ({ fetchType = 'daily-routine-staff' } = {}) => async (dispatch) => {
    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineStaff);
        if (status === 200) return data;
        throw new Error('Failed to fetch staff.');
    } catch (error) {
        throw error;
    }
}

export const FetchDailyRoutineFilterUsers = ({ fetchType = 'daily-routine-filter-users' } = {}) => async (dispatch) => {
    try {
        const { status, data } = await Axios.get(endPoints.accountability_dailyRoutineFilterUsers);
        if (status === 200) return data;
        throw new Error('Failed to fetch filter users.');
    } catch (error) {
        throw error;
    }
}

export const AcknowledgeMissedRx = ({ payload, missedType }) => async (dispatch) => {
    try {
        const { status } = await Axios.post(`${endPoints.accountability_acknCheckMissedRx}`, payload)
        if (status === 200) {
            // Missed 3x/4x: do not refetch the list after acknowledge (keeps table stable).
            // dispatch(getMissedRxData({
            //     fetchType: 'getMissedRxData',
            //     payload: {
            //         is_missed_rx: missedType
            //     },
            //     type: 'updateMissedRx'
            // }))
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
    }
}

export const AcknowledgeMissedRx_WrongPrep = ({ payload, setAcknResponse }) => async () => {
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_acknCheckMissedRx_WrongPrep}`, payload)
        if (status === 200) {
            const confirmedData = data?.data?.acknowledgment
            setAcknResponse(prevAcknResponse => { // Use the updater function!
                // Records with a winrxdata_id dedupe on it (unchanged).
                // rxnum-anchored records (never-billed EmergencySupply rows,
                // winrxdata_id null) dedupe on rxnum so two different
                // never-billed rows never evict each other.
                const uniqueAcknResponse = prevAcknResponse?.filter(value => confirmedData.winrxdata_id
                    ? value.winrxdata_id !== confirmedData.winrxdata_id
                    : !((value.winrxdata_id === null || value.winrxdata_id === '') && value.rxnum === confirmedData.rxnum));
                return [...uniqueAcknResponse, confirmedData];
            })
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
    }
}

export const AcknowledgeNotBilled = ({ payload, setAcknResponse }) => async (dispatch) => {
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_acknCheckNotBilled}`, payload)
        if (status === 200) {
            const confirmedData = data?.data?.acknowledgment
            setAcknResponse(prevAcknResponse => { // Use the updater function!
                const uniqueAcknResponse = prevAcknResponse.filter(item => item.id !== confirmedData.id);
                return [...uniqueAcknResponse, confirmedData];
            })
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
    }
}


// export const AcknowledgeWitnessCarry = ({ payload, setAcknResponse }) => async () => {
//     try {
//         const { status, data } = await Axios.post(`${endPoints.accountability_acknCheckWitnessCarry}`, payload)
//         if (status === 200) {
//             const confirmedData = data?.data?.acknowledgment
//             console.log(confirmedData, 'confirmedData')
//             console.log(data)
//             // setAcknResponse(prevAcknResponse => { // Use the updater function!
//             //     const uniqueAcknResponse = prevAcknResponse?.filter(value => value.winrxdata_id !== confirmedData.winrxdata_id);
//             //     return [...uniqueAcknResponse, confirmedData];
//             // })
//         }
//     } catch (error) {
//         showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
//     }
// }

export const AcknowledgeWitnessCarry =
    ({ payload, setAcknResponse }) =>
        async () => {
            try {
                const { status, data } = await Axios.post(
                    `${endPoints.accountability_acknCheckWitnessCarry}`,
                    payload
                );

                if (status === 200) {
                    const ack = data?.data || {};
                    const nextEntry = {
                        rx_number: payload?.rx_number,
                        witnessCarryAck:
                            ack?.witnessCarryAck ?? ack?.witness_carry_ack ?? 0,
                        witnessCarryAckName:
                            ack?.witnessCarryAckName ?? ack?.witness_carry_ack_name ?? "",
                    };

                    setAcknResponse((prev) => {
                        const prevArr = Array.isArray(prev) ? prev : [];

                        // If ack == 0 → remove from list
                        if (nextEntry.witnessCarryAck === 0) {
                            return prevArr.filter((row) => row.rx_number !== payload?.rx_number);
                        }

                        // Otherwise update/append
                        const idx = prevArr.findIndex(
                            (row) => row.rx_number === payload?.rx_number
                        );

                        if (idx !== -1) {
                            const updated = [...prevArr];
                            updated[idx] = { ...prevArr[idx], ...nextEntry };
                            return updated;
                        }

                        return [...prevArr, nextEntry];
                    });
                }
            } catch (error) {
                showToast(
                    error?.response?.data?.message ||
                    error.message ||
                    "Something went wrong",
                    "error"
                );
            }
        };



export const fetchPharmacyAccountabilityReport = ({ fetchType, payload, setLoadingStates }) => async (dispatch) => {


    dispatch(createAction(actionTypes.PHARMACY_ACCOUNTABILITY_REPORT.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_pharmacyAccountabilityReport}`, payload,
            {
                params: {
                    no_of_records: 200,
                },

            })

        if (status === 200) {

            const reportId = data?.data?.report_logs[0]?.id
            const count = data?.data?.count
            if (reportId && payload.is_filter && count > 0) {
                setLoadingStates(prev => ({ ...prev, [reportId]: true }));
                dispatch(HandleDownloadReport({
                    fetchType: `downloadReport-${reportId}`,
                    report_id: reportId
                }))

            }
            dispatch(createAction(actionTypes.PHARMACY_ACCOUNTABILITY_REPORT.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {

        dispatch(createAction(actionTypes.PHARMACY_ACCOUNTABILITY_REPORT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const fetchReportRouteList = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.REPORT_ROUTE_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_getReportRoutes}`, { params: payload })
        if (status === 200) {
            dispatch(createAction(actionTypes.REPORT_ROUTE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {

        dispatch(createAction(actionTypes.REPORT_ROUTE_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const HandleDownloadReport = ({ fetchType, report_id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DOWNLOAD_REPORT.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status } = await Axios.get(`${endPoints.accountability_downloadReport}`, {
            params: {
                report_id: report_id
            }
        })
        if (status === 200) {
            // dispatch(createAction(actionTypes.DOWNLOAD_REPORT.SUCCESS, {
            //     data: data,
            //     requestType: fetchType
            // }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.DOWNLOAD_REPORT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const GetAccountabilityFinalReport = ({ fetchType, report_id, dates, type }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DOWNLOAD_REPORT.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_getAccountabilityFinalReport}`, {
            params: {
                id: report_id,
                type: type
            }
        })
        if (status === 200) {
            const pdfLink = data?.report_pdf_base64
            // PreviewPdf(pdfLink)
            PreviewAndDownloadPdf(pdfLink, dates)
            dispatch(createAction(actionTypes.DOWNLOAD_REPORT.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
        dispatch(createAction(actionTypes.DOWNLOAD_REPORT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let getEmergencyReportAbortControllers = []
export const getEmergencyReport = ({ fetchType }) => async (dispatch) => {

    // ✅ Cancel ALL previous requests before new one starts
    getEmergencyReportAbortControllers.forEach(controller => controller.abort());
    getEmergencyReportAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    getEmergencyReportAbortControllers.push(controller);
    dispatch(createAction(actionTypes.EMERGENCY_REPORT.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(endPoints.accountability_getEmergencyReport, { signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.EMERGENCY_REPORT.SUCCESS, {
                data: data,
                requestType: fetchType
            }))
            return data

        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.EMERGENCY_REPORT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const downloadEmergencyReport = ({ fetchType, payload }) => async (dispatch) => {

    dispatch(createAction(actionTypes.DOWNLOAD_EMERGENCY_REPORT.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(endPoints.accountability_downloadEmergencyReport, { params: payload })
        if (status === 200) {
            const pdfLink = data?.merged_pdf_base64
            PreviewFileNamePdf(pdfLink, `emergency-doses-${payload.formatteddate}`)
            dispatch(createAction(actionTypes.DOWNLOAD_EMERGENCY_REPORT.SUCCESS, {
                data: data,
                requestType: fetchType
            }))

        }
    } catch (error) {
        dispatch(createAction(actionTypes.DOWNLOAD_EMERGENCY_REPORT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


// fetch change dose
export const fetchChangeDose = ({ fetchType, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.CHANGE_DOSE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const params = {
            page: pageNumber
        };

        const { status, data } = await Axios.get(`${endPoints.accountability_changeDose}`, { params });

        if (status === 200) {
            dispatch(createAction(actionTypes.CHANGE_DOSE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.CHANGE_DOSE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
};


// fetch change dose
export const fetchFutureChangingDose = ({ fetchType, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FUTURE_CHANGING_DOSE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const params = { page: pageNumber };

        const { status, data } = await Axios.get(`${endPoints.accountability_futureChangingDose}`, { params });

        if (status === 200) {
            dispatch(createAction(actionTypes.FUTURE_CHANGING_DOSE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FUTURE_CHANGING_DOSE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
};

export const ForceDropRoute = ({ fetchType, route }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FORCE_DROP_ROUTE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_forceDropActiveRoute}`, {
            route
        });

        if (status === 200) {
            dispatch(createAction(actionTypes.FORCE_DROP_ROUTE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FORCE_DROP_ROUTE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const handleMuteRX = ({ fetchType,
    payload,
    selectedPatient,
    prepButNotBilledPageNumber,
    prepButNotBilledSortType,
    formData,
    setShowMuteRXModal,
    onSuccess,
    type }) => async (dispatch) => {

        dispatch(createAction(actionTypes.MUTE_RX.REQUEST, {
            requestType: fetchType
        }));

        try {
            const { status, data } = await Axios.post(`${endPoints.accountability_updateMuteRX}`, payload);
            if (status === 200) {
                dispatch(createAction(actionTypes.MUTE_RX.SUCCESS, {
                    data: data,
                    requestType: fetchType
                }));
                if (type === 'prepcheck') {
                    dispatch(FetchPrepareCheckPatientPrescriptions({
                        patient_id: selectedPatient?.patient_id,
                        search_date: formData.date,
                        fetchType: 'patientPrescription',
                        next_number_of_days: formData?.next_number_of_days?.value,
                        medication_status: formData?.list_type?.value,
                        sort_by: formData?.sort_by?.value
                    }))
                }
                if (type === 'notbilled') {
                    dispatch(fetchPrepButNotBilled({
                        fetchType: 'fetchPrepButNotBilled',
                        pageNumber: prepButNotBilledPageNumber,
                        type: prepButNotBilledSortType || 'route'
                    }))
                }
                if (type === 'donotbilled') {
                    dispatch(FetchDoNotBill({
                        fetchType: 'fetchDoNotBill',
                        pageNumber: prepButNotBilledPageNumber,
                        type: prepButNotBilledSortType || 'route'
                    }))
                }
                if (type === 'investigate') {
                    window.location.href = `/pharmacy-investigate-rx?rx-number=${payload.rx_number}`
                }
                if (typeof onSuccess === 'function') {
                    onSuccess(data)
                }
                setShowMuteRXModal(false)
            }
        } catch (error) {
            showToast('Something went wrong', 'error')
            dispatch(createAction(actionTypes.MUTE_RX.FAILURE, {
                error: error?.response?.data?.message || error.message || 'Something went wrong',
                requestType: fetchType
            }));
        }
    }

export const DownloadBulkLabel = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DOWNLOAD_BULK_LABEL.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_downloadBulkLabel}`, { params: payload });
        if (status === 200) {
            dispatch(createAction(actionTypes.DOWNLOAD_BULK_LABEL.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            PreviewPdf(data?.data)
        }
    } catch (error) {
        dispatch(createAction(actionTypes.DOWNLOAD_BULK_LABEL.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const fetchOddBillingData = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ODD_BILLING.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_oddBilling}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.ODD_BILLING.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ODD_BILLING.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let patientDrugInformationSheetAbortControllers = []
export const fetchPatientDrugInformationSheet = ({ fetchType, payload, pageNumber }) => async (dispatch) => {
    patientDrugInformationSheetAbortControllers.forEach(controller => controller.abort());
    patientDrugInformationSheetAbortControllers = [];
    const controller = new AbortController();
    patientDrugInformationSheetAbortControllers.push(controller);

    dispatch(createAction(actionTypes.PATIENT_DRUG_INFORMATION_SHEET.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_patientDrugInformationSheet}`, { params: { ...payload, page: pageNumber, no_of_records: 50 }, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.PATIENT_DRUG_INFORMATION_SHEET.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.PATIENT_DRUG_INFORMATION_SHEET.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const handleDownloadPatientDrugInformationSheet = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DOWNLOAD_PATIENT_DRUG_INFORMATION_SHEET.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${payload.url}&medname=${payload.medname}`);
        if (status === 200) {
            PreviewPdf(data?.data?.pdf_content)
            dispatch(createAction(actionTypes.DOWNLOAD_PATIENT_DRUG_INFORMATION_SHEET.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
        dispatch(createAction(actionTypes.DOWNLOAD_PATIENT_DRUG_INFORMATION_SHEET.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let emergencyTodayDataAbortControllers = []
export const fetchEmergencyTodayData = ({ fetchType }) => async (dispatch) => {

    emergencyTodayDataAbortControllers.forEach(controller => controller.abort());
    emergencyTodayDataAbortControllers = [];
    const controller = new AbortController();
    emergencyTodayDataAbortControllers.push(controller);

    dispatch(createAction(actionTypes.EMERGENCY_TODAY_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        // const { status, data } = await Axios.get(`${endPoints.accountability_todayEmergencyRxData}`, { signal: controller.signal });
        const { status, data } = await Axios.get(`${endPoints.accountability_todayFirstEmergencyRx}?date=${currentDate}`, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.EMERGENCY_TODAY_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.EMERGENCY_TODAY_DATA.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Abort any ongoing requests used within the TodayMissedRx page
export const cancelTodayMissedRxRequests = () => {
    [
        fetchTodayMissedRxRouteListAbortControllers,
        fetchTodayMissedRxRouteListDetailsAbortControllers,
        fetchPrepButNotBilledAbortControllers,
        fetchFlexiDeliverAbortControllers,
        fetchBilledButNotPreparedAbortControllers,
        fetchWrongPrepAbortControllers,
        getMissedRxDataAbortControllers,
        getEmergencyReportAbortControllers,
        emergencyTodayDataAbortControllers,
        patientDrugInformationSheetAbortControllers,
    ].forEach((controllers) => {
        controllers.forEach((controller) => controller.abort());
    });

    fetchTodayMissedRxRouteListAbortControllers = [];
    fetchTodayMissedRxRouteListDetailsAbortControllers = [];
    fetchPrepButNotBilledAbortControllers = [];
    fetchFlexiDeliverAbortControllers = [];
    fetchBilledButNotPreparedAbortControllers = [];
    fetchWrongPrepAbortControllers = [];
    getMissedRxDataAbortControllers = [];
    getEmergencyReportAbortControllers = [];
    emergencyTodayDataAbortControllers = [];
    patientDrugInformationSheetAbortControllers = [];
};


export const fetchDWICounts = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DWI_COUNT.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_fetchDWICounts}`, { params: payload });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DWI_COUNT.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DWI_COUNT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const fetchWeeklyOddBillingSchedule = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.WEEKLY_ODD_BILLING_SCHEDULE.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_weeklyOddBillingSchedule}`, { params: payload });
        if (status === 200) {
            dispatch(createAction(actionTypes.WEEKLY_ODD_BILLING_SCHEDULE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.WEEKLY_ODD_BILLING_SCHEDULE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

//  Actions for Prep for New Rx Page

let prepForNewRxRouteListAbortControllers = []
export const FetchPrepForNewRxRouteList = ({ fetchType, params }) => async (dispatch) => {
    prepForNewRxRouteListAbortControllers.forEach(controller => controller.abort());
    prepForNewRxRouteListAbortControllers = [];
    const controller = new AbortController();
    prepForNewRxRouteListAbortControllers.push(controller);

    dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_ROUTE_LIST.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_newRxRouteList}`, { params: params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_ROUTE_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_ROUTE_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let prepForNewRxRouteDataAbortControllers = []

export const FetchPrepForNewRxRouteData = ({ fetchType, params }) => async (dispatch) => {
    prepForNewRxRouteDataAbortControllers.forEach(controller => controller.abort());
    prepForNewRxRouteDataAbortControllers = [];
    const controller = new AbortController();
    prepForNewRxRouteDataAbortControllers.push(controller);

    dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_ROUTE_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_newRxData}`, { params: params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_ROUTE_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_ROUTE_DATA.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

let fetchOddScheduleDynamicRxAbortControllers = []

export const FetchOddScheduleDynamicRx = ({ fetchType, params }) => async (dispatch) => {

    fetchOddScheduleDynamicRxAbortControllers.forEach(controller => controller.abort());
    fetchOddScheduleDynamicRxAbortControllers = [];
    const controller = new AbortController();
    fetchOddScheduleDynamicRxAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_ODD_SCHEDULE_DYNAMIC_RX.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_oddScheduleDynamicRx}`, { params: params, signal: controller.signal })
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_ODD_SCHEDULE_DYNAMIC_RX.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_ODD_SCHEDULE_DYNAMIC_RX.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Actions for Other Frequency Data
let fetchOtherFrequencyDataAbortControllers = []
export const FetchOtherFrequencyData = ({ fetchType }) => async (dispatch) => {

    fetchOtherFrequencyDataAbortControllers.forEach(controller => controller.abort());
    fetchOtherFrequencyDataAbortControllers = [];
    const controller = new AbortController();
    fetchOtherFrequencyDataAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_OTHER_FREQUENCY_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_otherFrequencyData}`, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_OTHER_FREQUENCY_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_OTHER_FREQUENCY_DATA.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Actions for Dilaudid Data
let fetchDilaudidDataAbortControllers = []
export const FetchDilaudidData = ({ fetchType }) => async (dispatch) => {
    fetchDilaudidDataAbortControllers.forEach(controller => controller.abort());
    fetchDilaudidDataAbortControllers = [];
    const controller = new AbortController();
    fetchDilaudidDataAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DILAUDID_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_dilaudidData}`, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DILAUDID_DATA.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DILAUDID_DATA.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Actions for Dilaudid Same Bid Data
let fetchDilaudidSameBidAbortControllers = []
export const FetchDilaudidSameBid = ({ fetchType, type = "", date = "" }) => async (dispatch) => {
    fetchDilaudidSameBidAbortControllers.forEach(controller => controller.abort());
    fetchDilaudidSameBidAbortControllers = [];
    const controller = new AbortController();
    fetchDilaudidSameBidAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DILAUDID_SAME_BID.REQUEST, {
        requestType: fetchType
    }));



    const url = type === "all" ? endPoints.accountability_dilaudid_rx_today_all : endPoints.accountability_dilaudid_same_bid

    try {
        const { status, data } = await Axios.get(`${url}`, { signal: controller.signal, params: { date: date } });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DILAUDID_SAME_BID.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DILAUDID_SAME_BID.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


// Actions for Dilaudid Same Bid Data
let fetchDilaudidFaxToDoctorAbortControllers = []
export const FetchDilaudidFaxToDoctor = ({ fetchType, payload, setFaxPopup }) => async (dispatch) => {
    const isConfirmed = await confirmSendFax();
    if (!isConfirmed) return;

    fetchDilaudidFaxToDoctorAbortControllers.forEach(controller => controller.abort());
    fetchDilaudidFaxToDoctorAbortControllers = [];
    const controller = new AbortController();
    fetchDilaudidFaxToDoctorAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DILAUDID_FAX_TO_DOCTOR.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_send_dilaudid_fax_to_doctor}`, payload, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DILAUDID_FAX_TO_DOCTOR.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            showToast('Fax sent successfully!', 'success')
            setFaxPopup({ show: false, doctorInfo: null })
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DILAUDID_FAX_TO_DOCTOR.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Actions for Dilaudid Different Bid Data
let fetchDilaudidDifferentBidAbortControllers = []
export const FetchDilaudidDifferentBid = ({ fetchType }) => async (dispatch) => {
    fetchDilaudidDifferentBidAbortControllers.forEach(controller => controller.abort());
    fetchDilaudidDifferentBidAbortControllers = [];
    const controller = new AbortController();
    fetchDilaudidDifferentBidAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DILAUDID_DIFFERENT_BID.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_dilaudid_different_bid}`, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DILAUDID_DIFFERENT_BID.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DILAUDID_DIFFERENT_BID.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Actions for Dilaudid Others Data
let fetchDilaudidOthersAbortControllers = []
export const FetchDilaudidOthers = ({ fetchType }) => async (dispatch) => {
    fetchDilaudidOthersAbortControllers.forEach(controller => controller.abort());
    fetchDilaudidOthersAbortControllers = [];
    const controller = new AbortController();
    fetchDilaudidOthersAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DILAUDID_OTHERS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_dilaudid_others}`, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DILAUDID_OTHERS.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DILAUDID_OTHERS.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Actions for the Non Safe Supply missed-dose tab.
// Same shape as the Dilaudid (Safe Supply) fetchers above - the two tabs are siblings.
let fetchNonSafeSupplyMissedDosesAbortControllers = []
export const FetchNonSafeSupplyMissedDoses = ({ fetchType, date = "", narcoticType = "all" }) => async (dispatch) => {
    fetchNonSafeSupplyMissedDosesAbortControllers.forEach(controller => controller.abort());
    fetchNonSafeSupplyMissedDosesAbortControllers = [];
    const controller = new AbortController();
    fetchNonSafeSupplyMissedDosesAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_NON_SAFE_SUPPLY_MISSED_DOSES.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_non_safe_supply_missed_doses}`, {
            signal: controller.signal,
            params: {
                date: date,
                ...(narcoticType !== 'all' ? { narcotic_type: narcoticType } : {})
            }
        });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_NON_SAFE_SUPPLY_MISSED_DOSES.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_NON_SAFE_SUPPLY_MISSED_DOSES.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Action to update PacmedTime
export const UpdatePacmedTime = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_PACMED_TIME.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_dilaudidRxOverwrite}`, payload);
        if (status === 200) {
            dispatch(createAction(actionTypes.UPDATE_PACMED_TIME.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data;
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
        dispatch(createAction(actionTypes.UPDATE_PACMED_TIME.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        throw error;
    }
}

// export const FetchPrepForNewRxCheck = ({ fetchType, params, setDoseData }) => async (dispatch) => {
//     dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_CHECK.REQUEST, {
//         requestType: fetchType
//     }));

//     try {
//         const { status, data } = await Axios.post(`${endPoints.accountability_newRxCheck}`, params);

//         if (status === 200) {
//             // Extract all values from the response
//             const { patient_id, records } = data?.data || {};

//             // Process each record in the records array
//             if (records && Array.isArray(records)) {
//                 records.forEach(record => {
//                     const { rxnumber, din, multiple_date } = record;

//                     // Process each date entry in multiple_date array
//                     if (multiple_date && Array.isArray(multiple_date)) {
//                         multiple_date.forEach(dateEntry => {
//                             const {
//                                 is_checked,
//                                 date,
//                                 assigned_by
//                             } = dateEntry;


//                             const responseData = {
//                                 patient_id: patient_id,
//                                 rx_number: rxnumber,
//                                 dose_info: [{
//                                     assigned_by: assigned_by,
//                                     formatted_prep_date: date, // Add this for consistency with the UI
//                                     prep_status: is_checked // Add this for status tracking
//                                 }]
//                             };

//                             setDoseData(prevResponse => {
//                                 const uniqueResponse = prevResponse?.filter(value =>
//                                     !(value.patient_id === responseData.patient_id &&
//                                         value.rx_number === responseData.rx_number &&
//                                         value.dose_info?.[0]?.formatted_prep_date === responseData.dose_info?.[0]?.formatted_prep_date)
//                                 );
//                                 return [...uniqueResponse, responseData];
//                             });
//                         });
//                     }
//                 });
//             }

//             dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_CHECK.SUCCESS, {
//                 data: data,
//                 requestType: fetchType
//             }));
//         }
//     } catch (error) {
//         dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_CHECK.FAILURE, {
//             error: error?.response?.data?.message || error.message || 'Something went wrong',
//             requestType: fetchType
//         }));
//     }
// }


export const FetchPrepForNewRxCheck = ({ fetchType, params }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_CHECK.REQUEST, { requestType: fetchType }));

    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_newRxCheck}`, params);

        if (status === 200) {
            const { patient_id, records } = data?.data || {};
            const updatedDoseData = [];

            if (records && Array.isArray(records)) {
                records.forEach(record => {
                    const { rxnumber, multiple_date } = record;

                    multiple_date?.forEach(entry => {
                        updatedDoseData.push({
                            patient_id,
                            rx_number: rxnumber,
                            dose_info: [{
                                formatted_prep_date: entry.date,
                                prep_status: entry.is_checked,
                                assigned_by: entry.assigned_by || [],
                                lot_number: entry.lot_number ?? null,
                                expiry_date: entry.expiry_date ?? null,
                                formatted_expiry_date: entry.formatted_expiry_date ?? null
                            }]
                        });
                    });
                });
            }

            dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_CHECK.SUCCESS, {
                data,
                requestType: fetchType
            }));

            return updatedDoseData; // ✅ returning this for UI update
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error');
        dispatch(createAction(actionTypes.PREP_FOR_NEW_RX_CHECK.FAILURE, {
            error: error?.response?.data?.message || error.message,
            requestType: fetchType
        }));
        return [];
    }
};


let fetchRxDosesNotGeneratedAbortControllers = []
export const FetchRxDosesNotGenerated = ({ fetchType, params }) => async (dispatch) => {
    fetchRxDosesNotGeneratedAbortControllers.forEach(controller => controller.abort());
    fetchRxDosesNotGeneratedAbortControllers = [];
    const controller = new AbortController();
    fetchRxDosesNotGeneratedAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_RX_DOSES_NOT_GENERATED.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_rxDosesNotGenerated}`, { params: params, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_RX_DOSES_NOT_GENERATED.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_RX_DOSES_NOT_GENERATED.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Action to fetch Dilaudid Rx Today PDF
export const FetchDilaudidRxTodayPdf = ({ fetchType, params }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DILAUDID_RX_TODAY_PDF.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_dilaudidRxTodayPdf}`, { params: params });
        if (status === 200) {
            // Preview the PDF using the existing helper function
            PreviewPdf(data?.data?.data || data?.data);
            dispatch(createAction(actionTypes.FETCH_DILAUDID_RX_TODAY_PDF.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error');
        dispatch(createAction(actionTypes.FETCH_DILAUDID_RX_TODAY_PDF.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const FetchPreviousDilaudidPdf = ({ fetchType, params }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_PREVIOUS_DILAUDID_PDF.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_dilaudidPreviousPdf}`, { params: params });
        if (status === 200) {
            // Preview the PDF using the existing helper function
            PreviewPdf(data?.data?.data || data?.data);
            dispatch(createAction(actionTypes.FETCH_PREVIOUS_DILAUDID_PDF.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error');
        dispatch(createAction(actionTypes.FETCH_PREVIOUS_DILAUDID_PDF.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const FetchDoNotBill = ({ fetchType, pageNumber = 1, type = 'route' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DO_NOT_BILL.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_prepCheck_sTsfRc}`, { params: { page: pageNumber, type: type } })
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DO_NOT_BILL.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DO_NOT_BILL.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const AcknowledgeDoNotBill = ({ payload, setAcknResponse }) => async () => {
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_acknCheckDoNotBill}`, payload)
        if (status === 200) {
            const confirmedData = data?.data?.acknowledgment
            setAcknResponse(prevAcknResponse => { // Use the updater function!
                const uniqueAcknResponse = prevAcknResponse?.filter(value => value.id !== confirmedData.id);
                return [...uniqueAcknResponse, confirmedData];
            })
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
    }
}


export const FetchArvRx = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_ARV_RX.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_arv_rxes}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_ARV_RX.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_ARV_RX.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const previewArvRxDataForFax = ({ fetchType, payload, type, tabType = '' }) => async (dispatch) => {
    if (type !== 'preview') {
        const isConfirmed = await confirmSendFax();
        if (!isConfirmed) return;
    }

    dispatch(createAction(actionTypes.PREVIEW_ARV_RX_DATA_FOR_FAX.REQUEST, {
        requestType: fetchType
    }));

    try {

        const urlArv = type === 'preview' ? endPoints.accountability_arv_rx_data_preview_for_fax : endPoints.accountability_arv_rx_send_fax
        const urlRefills = type === 'preview' ? endPoints.accountability_refills_data_preview_for_fax : endPoints.accountability_refills_send_fax
        const url = tabType === 'refills' ? urlRefills : urlArv
        const { status, data } = await Axios.post(url, payload);
        if (status === 200) {
            PreviewPdf(data?.data);
            dispatch(createAction(actionTypes.PREVIEW_ARV_RX_DATA_FOR_FAX.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        showToast('Please Generate Fax First', 'error')
        dispatch(createAction(actionTypes.PREVIEW_ARV_RX_DATA_FOR_FAX.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}



let fetchArvRxFaxListAbortControllers = []
export const FetchArvRxFaxList = ({ fetchType, tabType = '' }) => async (dispatch) => {
    fetchArvRxFaxListAbortControllers.forEach(controller => controller.abort());
    fetchArvRxFaxListAbortControllers = [];
    const controller = new AbortController();
    fetchArvRxFaxListAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_ARV_RX_FAX_LIST.REQUEST, {
        requestType: fetchType
    }));
    try {
        const urlArv = endPoints.accountability_arv_rx_fax_list
        const urlRefills = endPoints.accountability_refills_fax_list
        const url = tabType === 'refills' ? urlRefills : urlArv
        const { status, data } = await Axios.get(url, { signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_ARV_RX_FAX_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_ARV_RX_FAX_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const ArvRxFaxViewPdf = ({ fetchType, payload, tabType = '' }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ARV_RX_FAX_VIEW_PDF.REQUEST, {
        requestType: fetchType
    }));

    try {
        const urlArv = endPoints.accountability_arv_rx_fax_view_pdf
        const urlRefills = `${endPoints.accountability_refills_fax_view_pdf}/${payload.log_id}`
        const url = tabType === 'refills' ? urlRefills : urlArv
        let status, data
        if (tabType === 'refills') {
            ({ status, data } = await Axios.get(url, { params: payload }));
        } else {
            ({ status, data } = await Axios.post(url, payload));
        }
        if (status === 200) {
            PreviewPdf(data?.data);
            dispatch(createAction(actionTypes.ARV_RX_FAX_VIEW_PDF.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        showToast('Something went wrong', 'error')
        dispatch(createAction(actionTypes.ARV_RX_FAX_VIEW_PDF.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const FetchRefillsRequest = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_REFILLS_REQUEST.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_refills_request}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_REFILLS_REQUEST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_REFILLS_REQUEST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const FetchDrugFamilyList = ({ fetchType, params }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST.REQUEST, {
        requestType: fetchType
    }));


    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_refills_drug_family_list}`, { params });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }

}

let fetchDrugFamilyListPatientAbortControllers = []
export const FetchDrugFamilyListPatient = ({ fetchType, params }) => async (dispatch) => {
    fetchDrugFamilyListPatientAbortControllers.forEach(controller => controller.abort());
    fetchDrugFamilyListPatientAbortControllers = [];
    const controller = new AbortController();
    fetchDrugFamilyListPatientAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST_PATIENT.REQUEST, {
        requestType: fetchType
    }));

    const payload = {
        ...params,
    }


    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_refills_drug_family_list_patient}`, { ...payload, signal: controller.signal });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST_PATIENT.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST_PATIENT.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }

}


let fetchDrugFamilyListAnalyticsAbortControllers = []

export const FetchDrugFamilyListAnalytics = ({ fetchType, params, type = true }) => async (dispatch) => {
    fetchDrugFamilyListAnalyticsAbortControllers.forEach(controller => controller.abort());
    fetchDrugFamilyListAnalyticsAbortControllers = [];
    const controller = new AbortController();
    fetchDrugFamilyListAnalyticsAbortControllers.push(controller);

    if (type) {
        dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST_ANALYTICS.REQUEST, {
            reques0tType: fetchType
        }));
    }

    const payload = {
        ...params,
        no_of_records: 25
    }
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_refills_drug_family_list_analytics}`, { params: payload });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST_ANALYTICS.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DRUG_FAMILY_LIST_ANALYTICS.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}




let fetchDrugQuantityByDateAbortControllers = []

export const FetchDrugQuantityByDate = ({ fetchType, params }) => async (dispatch) => {
    fetchDrugQuantityByDateAbortControllers.forEach(controller => controller.abort());
    fetchDrugQuantityByDateAbortControllers = [];
    const controller = new AbortController();
    fetchDrugQuantityByDateAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_DRUG_QUANTITY_BY_DATE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const newParams = {
            ...params,
            start_date: formatDateToYYYYMMDD_CA(params.start_date),
            end_date: formatDateToYYYYMMDD_CA(params.end_date)
        }
        const { status, data } = await Axios.get(`${endPoints.accountability_drug_quantity_by_date}`, { 
            params: newParams,
            signal: controller.signal 
        });
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUG_QUANTITY_BY_DATE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_DRUG_QUANTITY_BY_DATE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const GenerateFaxPdf = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.GENERATE_FAX_PDF.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_generate_fax_pdf}`, payload);
        if (status === 200) {
            PreviewPdf(data?.data?.base64)
            dispatch(createAction(actionTypes.GENERATE_FAX_PDF.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.GENERATE_FAX_PDF.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}


export const FetchScheduleRx = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_SCHEDULE_RX.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.post(`${endPoints.accountability_schedule_rx}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_SCHEDULE_RX.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_SCHEDULE_RX.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const FetchDrugVisualIntakeMissingDins = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.FETCH_DRUG_VISUAL_INTAKE_MISSING_DINS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(`${endPoints.accountability_drug_visual_intake_missing_dins}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_DRUG_VISUAL_INTAKE_MISSING_DINS.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_DRUG_VISUAL_INTAKE_MISSING_DINS.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const SaveDrugVisualIntake = ({ fetchType, payload, setSelectedDin, setShowForm }) => async (dispatch) => {
    dispatch(createAction(actionTypes.SAVE_DRUG_VISUAL_INTAKE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await axios.post(`${process.env.REACT_APP_BASE_URL}${endPoints.drug_visual_intake}`, payload, {
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${authToken()}`,
                'Content-Type': 'multipart/form-data',
            }
        })

        if (status === 200) {
            dispatch(FetchDrugVisualIntakeMissingDins({ fetchType: 'fetchDrugVisualIntakeMissingDins' }));
            // showToast('Saved successfully', 'success')
            toast.success('Saved successfully', { autoClose: 2000 }); // Close toast after 2 seconds
            setSelectedDin(null);
            setShowForm(false);
            dispatch(createAction(actionTypes.SAVE_DRUG_VISUAL_INTAKE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return data;
        }
    } catch (error) {
        // showToast(error?.response?.data?.message, 'error')
        toast.error(error?.response?.data?.message, { autoClose: 2000 });
        dispatch(createAction(actionTypes.SAVE_DRUG_VISUAL_INTAKE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
        // throw error;
    }
}


export const FetchMissingWitnessCarryRx = ({ fetchType, pageNumber = 1, formData }) => async (dispatch) => {
    dispatch(createAction(actionTypes.MISSING_WITNESS_CARRY_RX.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            page: pageNumber,
            per_page: 100,
        }

        if (formData?.narcotic_type.value) {
            params.din_filter = formData.narcotic_type.value
        } else {
            params.din_filter = 'all'
        }

        if (formData?.acknowledged.value) {
            params.ack_filter  = formData.acknowledged.value
        }

        const { status, data } = await Axios.get(`${endPoints.accountability_missing_witness_carry_rx}`, { params });

        if (status === 200) {
            dispatch(createAction(actionTypes.MISSING_WITNESS_CARRY_RX.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.MISSING_WITNESS_CARRY_RX.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Fetches today's new RX list
// backgroundRefresh: when true, skips REQUEST dispatch to avoid showing skeleton and clearing existing data
let fetchNewRxListAbortControllers = []
export const FetchNewRxList = ({ fetchType, backgroundRefresh = false }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    fetchNewRxListAbortControllers.forEach(controller => controller.abort());
    fetchNewRxListAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchNewRxListAbortControllers.push(controller);

    if (!backgroundRefresh) {
        dispatch(createAction(actionTypes.FETCH_NEW_RX_LIST.REQUEST, {
            requestType: fetchType
        }));
    }

    try {
        const { status, data } = await Axios.get(`${endPoints.pharmacy_new_rx_list}`, { signal: controller.signal });
       

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_NEW_RX_LIST.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
            return { success: true, data }; // Return success indicator
        }
    } catch (error) {
        // Don't dispatch error if request was cancelled
        if (error.name === 'CanceledError' || error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
            return { success: false, error: null };
        }
        if (!backgroundRefresh) {
            dispatch(createAction(actionTypes.FETCH_NEW_RX_LIST.FAILURE, {
                error: error?.response?.data?.message || error.message || 'Something went wrong',
                requestType: fetchType
            }));
        }
        return { success: false, error };
    }
}

// Fetches narcotic RX list by date
let fetchNarcoticRxByDateAbortControllers = []
export const FetchNarcoticRxByDate = ({ fetchType, params }) => async (dispatch) => {
    // ✅ Cancel ALL previous requests before new one starts
    fetchNarcoticRxByDateAbortControllers.forEach(controller => controller.abort());
    fetchNarcoticRxByDateAbortControllers = []; // Clear the array

    // 🆕 Create new controller
    const controller = new AbortController();
    fetchNarcoticRxByDateAbortControllers.push(controller);

    dispatch(createAction(actionTypes.FETCH_NARCOTIC_RX_BY_DATE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const { status, data } = await Axios.get(`${endPoints.pharmacy_narcotic_rx_by_date}`, { 
            params: params,
            signal: controller.signal 
        });

        if (status === 200) {
            dispatch(createAction(actionTypes.FETCH_NARCOTIC_RX_BY_DATE.SUCCESS, {
                data: data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            return;
        }
        dispatch(createAction(actionTypes.FETCH_NARCOTIC_RX_BY_DATE.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

export const PrintArchivedRxSheet = ({ rxnumber, patientId, setPrintLoading }) => async () => {
    try {
        if (!rxnumber || !patientId) {
            showToast('RX number and Patient ID are required', 'error');
            if (setPrintLoading) {
                setPrintLoading(prev => ({ ...prev, [rxnumber]: false }));
            }
            return;
        }

        const { status, data } = await Axios.get(`${endPoints.pharmacy_patient_archieved_sheet}/${rxnumber}/${patientId}?mapping=false`);

        if (status === 200 && data?.data) {
            PreviewPdf(data.data);
        } else {
            throw new Error('Failed to fetch sheet');
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Failed to print sheet. Please try again.', 'error');
    } finally {
        // Clear loading state after API response (success or error)
        if (setPrintLoading) {
            setPrintLoading(prev => ({ ...prev, [rxnumber]: false }));
        }
    }
}

export const AcknowledgeRxSheet = ({ rxnumber, acknowledged, setAcknowledgedRx, setRxAcknowledgments }) => async () => {
    try {
        if (!rxnumber) {
            showToast('RX number is required', 'error');
            return;
        }

        const payload = {
            type: 'rxsheet',
            acknowledged: acknowledged,
            rxnumber: rxnumber
        };

        const { status, data } = await Axios.post(`${endPoints.pharmacy_rx_acknowledge}`, payload);

        if (status === 200 && data?.success) {
            const responseData = data?.data;
            const isAcknowledged = responseData?.acknowledged === true;
            
            // Update acknowledged state based on response (for checkbox)
            if (setAcknowledgedRx) {
                setAcknowledgedRx(prev => {
                    if (isAcknowledged) {
                        // Add/update acknowledged RX with details
                        return {
                            ...prev,
                            [rxnumber]: {
                                acknowledged_by_name: responseData?.acknowledged_by_name || '',
                                acknowledged_at: responseData?.acknowledged_at || ''
                            }
                        };
                    } else {
                        // Remove from acknowledged list
                        const updated = { ...prev };
                        delete updated[rxnumber];
                        return updated;
                    }
                });
            }

            // Update rxAcknowledgments (for display) - add new acknowledgment at the top
            if (setRxAcknowledgments) {
                setRxAcknowledgments(prev => {
                    if (isAcknowledged) {
                        const newAck = {
                            acknowledged_by_name: responseData?.acknowledged_by_name || '',
                            acknowledged_at: responseData?.acknowledged_at || ''
                        };
                        
                        // Get existing acknowledgments for this RX
                        const existingAcks = prev[rxnumber] || [];
                        
                        // Check if this acknowledgment already exists (avoid duplicates)
                        const ackExists = existingAcks.some(ack => 
                            ack.acknowledged_by_name === newAck.acknowledged_by_name &&
                            ack.acknowledged_at === newAck.acknowledged_at
                        );
                        
                        if (!ackExists) {
                            // Add new acknowledgment at the beginning (top)
                            return {
                                ...prev,
                                [rxnumber]: [newAck, ...existingAcks]
                            };
                        }
                        return prev;
                    } else {
                        // Remove acknowledgment from list
                        const updated = { ...prev };
                        if (updated[rxnumber]) {
                            const filteredAcks = updated[rxnumber].filter(ack => 
                                !(ack.acknowledged_by_name === responseData?.acknowledged_by_name &&
                                  ack.acknowledged_at === responseData?.acknowledged_at)
                            );
                            if (filteredAcks.length > 0) {
                                updated[rxnumber] = filteredAcks;
                            } else {
                                delete updated[rxnumber];
                            }
                        }
                        return updated;
                    }
                });
            }
            // Don't show success toast as per requirement
        } else {
            throw new Error('Failed to acknowledge RX');
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Failed to acknowledge RX. Please try again.', 'error');
        // Revert the state on error
        if (setAcknowledgedRx) {
            setAcknowledgedRx(prev => {
                const updated = { ...prev };
                if (acknowledged) {
                    // Remove on error if we were trying to acknowledge
                    delete updated[rxnumber];
                } else {
                    // Restore on error if we were trying to un-acknowledge
                    // We don't have the old data, so we'll just keep it as is
                }
                return updated;
            });
        }
    }
}

export const FetchInventoryAccountabilityDashboard = ({ fetchType = 'inventoryAccountabilityDashboard', params = {} } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_DASHBOARD.REQUEST, { requestType: fetchType }));

    try {
        const { status, data } = await Axios.get(`${endPoints.inventory_accountability_dashboard}`, { params });
        if (status === 200) {
            const responseData = data?.data ?? data;
            dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_DASHBOARD.SUCCESS, {
                data: responseData,
                requestType: fetchType
            }));
            return { success: true, data: responseData };
        }
        return { success: false, error: data?.message || 'Request failed' };
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_DASHBOARD.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        return { success: false, error: errMsg };
    }
}

// The doses behind one clubbed report line. Read-only and short-lived: the
// drawer holds the rows itself, so this never touches the store.
export const FetchInventoryAccountabilityReportDetails = ({ params = {} } = {}) => async () => {
    try {
        const { status, data } = await Axios.get(`${endPoints.inventory_accountability_reports_details}`, { params });
        if (status === 200) return { success: true, data: data?.data ?? data };
        return { success: false, error: data?.message || 'Request failed' };
    } catch (error) {
        return { success: false, error: error?.response?.data?.message || error.message || 'Something went wrong' };
    }
};

export const FetchInventoryAccountabilityReports = ({ fetchType = 'inventoryAccountabilityReports', params = {} } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORTS.REQUEST, { requestType: fetchType }));

    try {
        const { status, data } = await Axios.get(`${endPoints.inventory_accountability_reports}`, { params });
        if (status === 200) {
            const responseData = data?.data ?? data;
            dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORTS.SUCCESS, {
                data: responseData,
                requestType: fetchType
            }));
            return { success: true, data: responseData };
        }
        return { success: false, error: data?.message || 'Request failed' };
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORTS.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        return { success: false, error: errMsg };
    }
}

export const ExportInventoryAccountabilityReportPdf = ({ fetchType = 'inventoryAccountabilityReportPdf', params = {} } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORT_PDF.REQUEST, { requestType: fetchType }));

    try {
        const { status, data } = await Axios.get(`${endPoints.inventory_accountability_reports_export_pdf}`, { params });

        if (status === 200) {
            const responseData = data?.data ?? data;
            const pdfBase64 = responseData?.pdf;
            const fileName = responseData?.file_name || 'inventory-accountability-report.pdf';

            if (!pdfBase64) {
                throw new Error('PDF response is missing.');
            }

            PreviewFileNamePdf(pdfBase64, fileName);
            dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORT_PDF.SUCCESS, {
                data: { fileName },
                requestType: fetchType
            }));
            return { success: true, data: { fileName } };
        }

        return { success: false, error: 'Request failed' };
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong while downloading report PDF';
        dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORT_PDF.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        showToast(errMsg, 'error');
        return { success: false, error: errMsg };
    }
}

export const ExportInventoryAccountabilityReportCsv = ({ fetchType = 'inventoryAccountabilityReportCsv', params = {} } = {}) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORT_CSV.REQUEST, { requestType: fetchType }));

    try {
        const { status, data } = await Axios.get(`${endPoints.inventory_accountability_reports_export_csv}`, { params });

        if (status === 200) {
            const responseData = data?.data ?? data;
            const csvBase64 = responseData?.csv;
            const fileName = responseData?.file_name || 'inventory-accountability-report.csv';

            if (!csvBase64) {
                throw new Error('CSV response is missing.');
            }

            const link = document.createElement('a');
            link.href = `data:${responseData?.mime_type || 'text/csv'};base64,${csvBase64}`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORT_CSV.SUCCESS, {
                data: { fileName },
                requestType: fetchType
            }));
            return { success: true, data: { fileName } };
        }

        return { success: false, error: 'Request failed' };
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong while downloading report CSV';
        dispatch(createAction(actionTypes.INVENTORY_ACCOUNTABILITY_REPORT_CSV.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        showToast(errMsg, 'error');
        return { success: false, error: errMsg };
    }
}

// Shared request runner for inventory accountability thunks (identical REQUEST/SUCCESS/FAILURE semantics).
const runInventoryAccountabilityRequest = (actionType, fetchType, requestFn) => async (dispatch) => {
    dispatch(createAction(actionType.REQUEST, { requestType: fetchType }));

    try {
        const { status, data } = await requestFn();
        if (status === 200 || status === 201) {
            const responseData = data?.data ?? data;
            dispatch(createAction(actionType.SUCCESS, {
                data: responseData,
                requestType: fetchType
            }));
            // The server's own wording, so a screen can say what actually
            // happened rather than guessing from the payload - "those invoices
            // are already on their way" reads very differently from "getting
            // your invoices".
            return { success: true, data: responseData, message: data?.message };
        }
        return { success: false, error: data?.message || 'Request failed', status };
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionType.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        return { success: false, error: errMsg, status: error?.response?.status };
    }
}

// GET the saved distributor accounts: { distributors: [{ id, supplier_code, customer_number, username, active, has_password }] }
// A 404 means the backend list API is not deployed yet; callers fall back to the legacy single-account settings.
export const FetchInventoryAccountabilityDistributors = ({ fetchType = 'inventoryAccountabilityDistributors' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DISTRIBUTORS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_distributors}`));

// POST create/update a distributor account: { id?, supplier_code, customer_number, username, password?, active }
// Blank password on an existing account keeps the stored one.
export const SaveInventoryAccountabilityDistributor = ({ fetchType = 'inventoryAccountabilityDistributorSave', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_SAVE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_distributors}`, payload));

// DELETE a saved distributor account.
export const DeleteInventoryAccountabilityDistributor = ({ fetchType = 'inventoryAccountabilityDistributorDelete', distributorId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_DELETE, fetchType,
        () => Axios.delete(`${endPoints.inventory_accountability_distributors}/${distributorId}`));

// GET read-only WinRx spot check for up to 50 DINs: params { dins: 'din1,din2,...' }
// -> { comparisons: [{ din, winrx_qty }] }. 502 = WinRx unreachable.
export const FetchInventoryAccountabilityWinrxComparison = ({ fetchType = 'inventoryAccountabilityWinrxComparison', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_WINRX_COMPARISON, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_winrx_comparison}`, { params }));

// ---- Supplier returns (send stock back to the distributor for credit) ----

// GET paginated supplier returns: params { page, per_page }
export const FetchInventoryAccountabilitySupplierReturns = ({ fetchType = 'inventoryAccountabilitySupplierReturns', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURNS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_supplier_returns}`, { params }));

// POST create a draft supplier return: { drug_id, qty, lot_id?, supplier_name, reason, authorization_number? }
export const CreateInventoryAccountabilitySupplierReturn = ({ fetchType = 'inventoryAccountabilitySupplierReturnCreate', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREATE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_supplier_returns}`, payload));

// POST mark a draft return shipped (reduces stock).
export const ShipInventoryAccountabilitySupplierReturn = ({ fetchType = 'inventoryAccountabilitySupplierReturnShip', returnId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_SHIP, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_supplier_returns}/${returnId}/ship`));

// POST record the supplier credit: { credit_amount? }
export const CreditInventoryAccountabilitySupplierReturn = ({ fetchType = 'inventoryAccountabilitySupplierReturnCredit', returnId, payload = {} }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREDIT, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_supplier_returns}/${returnId}/credit`, payload));

// ---- Recalls (quarantine affected lots immediately) ----

// GET paginated recalls: params { page, per_page }
export const FetchInventoryAccountabilityRecalls = ({ fetchType = 'inventoryAccountabilityRecalls', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECALLS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_recalls}`, { params }));

// POST open a recall (locks matching lots): { din? and/or lot_number?, description }
export const CreateInventoryAccountabilityRecall = ({ fetchType = 'inventoryAccountabilityRecallCreate', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECALL_CREATE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_recalls}`, payload));

// GET one recall with its impact summary.
export const FetchInventoryAccountabilityRecall = ({ fetchType = 'inventoryAccountabilityRecallDetail', recallId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECALL_DETAIL, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_recalls}/${recallId}`));

// POST close a recall: { action_taken }
export const CloseInventoryAccountabilityRecall = ({ fetchType = 'inventoryAccountabilityRecallClose', recallId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECALL_CLOSE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_recalls}/${recallId}/close`, payload));

// GET the national Health Canada feed: params { page, per_page, search, recall_class }
export const FetchHealthCanadaRecalls = ({ fetchType = 'healthCanadaRecalls', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.HEALTH_CANADA_RECALLS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_recalls}/health-canada`, { params }));

// PATCH where a lot is stored: { storage_location }
export const UpdateInventoryAccountabilityLotLocation = ({ fetchType = 'inventoryAccountabilityLotLocation', lotId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_LOT_LOCATION, fetchType,
        () => Axios.patch(`${endPoints.inventory_accountability_lots}/${lotId}/location`, payload));

// GET the delivery->stock sync health: { last_synced_at, movements_synced, status, runs: [...] }
export const FetchInventoryAccountabilitySyncStatus = ({ fetchType = 'inventoryAccountabilitySyncStatus' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SYNC_STATUS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_sync_status}`));

// GET setup/import profile status, including completed and available import types.
export const FetchInventoryAccountabilitySetupStatus = ({ fetchType = 'inventoryAccountabilitySetupStatus' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SETUP_STATUS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_setup_status}`));

// POST WinRx stock import: { import_type, dins? }
export const ImportInventoryAccountabilitySetupWinrx = ({ fetchType = 'inventoryAccountabilitySetupImport', payload = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_SETUP_IMPORT, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_setup_import_winrx}`, payload));

// PATCH low-stock threshold for a drug.
export const UpdateInventoryAccountabilityThreshold = ({ fetchType = 'inventoryAccountabilityThreshold', drugId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_THRESHOLD, fetchType,
        () => Axios.patch(`${endPoints.inventory_accountability_drugs}/${drugId}/threshold`, payload));

// GET lots for a drug (used by the per-lot count drawer): { lots: [{ id, lot_number, expiry_date, qty }] }
export const FetchInventoryAccountabilityDrugLots = ({ fetchType = 'inventoryAccountabilityDrugLots', drugId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DRUG_LOTS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_drugs}/${drugId}/lots`));

// GET the exact Prep Check rows behind one dashboard PREP quantity.
// GET the prescriptions behind one number on a stock row.
// params { din, bucket: prepared|out|delivered, date }
export const FetchInventoryAccountabilityDoseDetails = ({ fetchType = 'inventoryAccountabilityDoseDetails', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DOSE_DETAILS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_dose_details}`, { params }));

// GET the stock ledger behind a drug's on-hand figure: params { date, no_of_records }
export const FetchInventoryAccountabilityDrugMovements = ({ fetchType = 'inventoryAccountabilityDrugMovements', drugId, params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DRUG_MOVEMENTS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_drugs}/${drugId}/movements`, { params }))

// POST split unassigned stock into lots: { lots: [{ lot_number, expiry_date, qty }] }
export const AssignInventoryAccountabilityDrugLots = ({ fetchType = 'inventoryAccountabilityLotsAssign', drugId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_LOTS_ASSIGN, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_drugs}/${drugId}/lots/assign`, payload));

// POST a manual stock adjustment: { drug_id, type, qty, lot_id?, reason } -> { on_hand_qty? }
export const SaveInventoryAccountabilityAdjustment = ({ fetchType = 'inventoryAccountabilityAdjustmentSave', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_ADJUSTMENT_SAVE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_adjustments}`, payload));

// ---- Returns queue (patient/route returns waiting for a restock decision) ----

// GET paginated returns queue: params { page, per_page, status(waiting_check|checked|restocked) }
export const FetchInventoryAccountabilityReturnsQueue = ({ fetchType = 'inventoryAccountabilityReturnsQueue', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RETURNS_QUEUE, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_returns_queue}`, { params }));

// POST restock a returned item: { qty, condition: intact|damaged, lot_id? | lot_number? + expiry_date? }. 409 = already handled.
export const RestockInventoryAccountabilityReturn = ({ fetchType = 'inventoryAccountabilityReturnRestock', returnId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RETURN_RESTOCK, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_returns_queue}/${returnId}/restock`, payload));

// ---- Destruction batches ----

// GET paginated destruction batches: params { page, per_page }
export const FetchInventoryAccountabilityDestructionBatches = ({ fetchType = 'inventoryAccountabilityDestructionList', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_LIST, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_destruction}`, { params }));

// POST create a draft batch: { items: [{ drug_id, qty, lot_id?, source, reason? }], notes? }
export const CreateInventoryAccountabilityDestructionBatch = ({ fetchType = 'inventoryAccountabilityDestructionCreate', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_CREATE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_destruction}`, payload));

// GET one batch with its items.
export const FetchInventoryAccountabilityDestructionBatch = ({ fetchType = 'inventoryAccountabilityDestructionDetail', batchId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_DETAIL, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_destruction}/${batchId}`));

// POST add an item to a draft batch: { drug_id, qty, lot_id?, source, reason? }
export const AddInventoryAccountabilityDestructionItem = ({ fetchType = 'inventoryAccountabilityDestructionItemAdd', batchId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_ADD, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_destruction}/${batchId}/items`, payload));

// DELETE an item from a draft batch.
export const RemoveInventoryAccountabilityDestructionItem = ({ fetchType = 'inventoryAccountabilityDestructionItemRemove', batchId, itemId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_REMOVE, fetchType,
        () => Axios.delete(`${endPoints.inventory_accountability_destruction}/${batchId}/items/${itemId}`));

// POST cancel a draft batch.
export const CancelInventoryAccountabilityDestructionBatch = ({ fetchType = 'inventoryAccountabilityDestructionCancel', batchId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_CANCEL, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_destruction}/${batchId}/cancel`));

// POST complete a batch (reduces stock): { witnessed_by, destruction_method }
export const CompleteInventoryAccountabilityDestructionBatch = ({ fetchType = 'inventoryAccountabilityDestructionComplete', batchId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DESTRUCTION_COMPLETE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_destruction}/${batchId}/complete`, payload));

// ---- Count sessions (formal, signable counts) ----

// GET paginated count sessions: params { page, per_page }
export const FetchInventoryAccountabilityCountSessions = ({ fetchType = 'inventoryAccountabilityCountSessions', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNT_SESSIONS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_count_sessions}`, { params }));

// POST start a session: { count_type: quarterly_narcotic|full|controlled|spot, blind, drug_ids? }
export const CreateInventoryAccountabilityCountSession = ({ fetchType = 'inventoryAccountabilityCountSessionCreate', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CREATE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_count_sessions}`, payload));

// GET one session with paginated lines: params { page, per_page, search? }
export const FetchInventoryAccountabilityCountSession = ({ fetchType = 'inventoryAccountabilityCountSessionDetail', sessionId, params = {} }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNT_SESSION_DETAIL, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_count_sessions}/${sessionId}`, { params }));

// POST record a counted amount for one line: { counted_qty }
export const SaveInventoryAccountabilityCountSessionLine = ({ fetchType = 'inventoryAccountabilityCountSessionLine', sessionId, lineId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNT_SESSION_LINE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_count_sessions}/${sessionId}/lines/${lineId}/count`, payload));

// POST sign & lock a session. 422 = some lines still uncounted.
export const SignInventoryAccountabilityCountSession = ({ fetchType = 'inventoryAccountabilityCountSessionSign', sessionId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNT_SESSION_SIGN, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_count_sessions}/${sessionId}/sign`));

// POST cancel an open session.
export const CancelInventoryAccountabilityCountSession = ({ fetchType = 'inventoryAccountabilityCountSessionCancel', sessionId }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CANCEL, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_count_sessions}/${sessionId}/cancel`));

// GET drug list for manual invoice-line matching: params { search, per_page } -> { drugs: [{ id, drug_name, din, strength }] }
export const SearchInventoryAccountabilityDrugs = ({ fetchType = 'inventoryAccountabilityDrugSearch', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DRUG_SEARCH, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_drug_search}`, { params }));

// GET paginated physical counts (params: page, per_page, search, status: open|matched|resolved).
export const FetchInventoryAccountabilityCounts = ({ fetchType = 'inventoryAccountabilityCounts', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COUNTS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_counts}`, { params }));

// POST per-lot physical count for a drug: { counts: [{ lot_id, lot_number, expiry_date, counted_qty }], variance_reason }
export const SaveInventoryAccountabilityPhysicalCount = ({ fetchType = 'inventoryAccountabilityPhysicalCount', drugId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_PHYSICAL_COUNT, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_drugs}/${drugId}/physical-count`, payload));

// POST resolve an open discrepancy: { resolution_reason }
export const ResolveInventoryAccountabilityDiscrepancy = ({ fetchType = 'inventoryAccountabilityDiscrepancyResolve', discrepancyId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_DISCREPANCY_RESOLVE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_discrepancies}/${discrepancyId}/resolve`, payload));

// GET paginated receiving invoices (params: page, per_page, date_from, date_to, search).
export const FetchInventoryAccountabilityReceivingReports = ({ fetchType = 'inventoryAccountabilityReceivingList', params = {} } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_LIST, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_receiving}`, { params }));

// GET paginated lines of one invoice (params: page, per_page, search, match_status: matched|needs_match).
export const FetchInventoryAccountabilityReceivingLines = ({ fetchType = 'inventoryAccountabilityReceivingLines', reportId, params = {} }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_LINES, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_receiving}/${reportId}/lines`, { params }));

// POST queue a McKesson invoice fetch for a date range: { date_from, date_to }
// Returns straight away with the queued job; the invoices arrive later, so callers poll the status endpoint.
export const ImportInventoryAccountabilityMckessonInvoice = ({ fetchType = 'inventoryAccountabilityReceivingMckessonImport', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving_mckesson_import}`, payload));

// GET where the queued McKesson fetch got to: { import: { status: queued|running|finished|failed,
// imported_count, skipped_invoices, last_error, ... } }. `import` is null when none was ever requested.
export const FetchInventoryAccountabilityMckessonImportStatus = ({ fetchType = 'inventoryAccountabilityReceivingMckessonImportStatus' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT_STATUS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_receiving_mckesson_import_status}`));

// POST persist an imported McKesson invoice with its lines.
export const SaveInventoryAccountabilityMckessonInvoice = ({ fetchType = 'inventoryAccountabilityReceivingMckessonSave', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_SAVE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving_mckesson_save}`, payload));

// POST refresh the distributor UPC/DIN catalog used for auto-matching.
export const RefreshInventoryAccountabilityCatalog = ({ fetchType = 'inventoryAccountabilityCatalogRefresh' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_CATALOG_REFRESH, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving_catalog_refresh}`));

// GET how many catalog products are stored and how old the list is.
export const FetchInventoryAccountabilityCatalogStatus = ({ fetchType = 'inventoryAccountabilityCatalogStatus' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_CATALOG_STATUS, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_receiving_catalog_status}`));

// GET prepared items (OAT codes) and the bulk product each is poured from.
export const FetchInventoryAccountabilityCompoundSources = ({ fetchType = 'inventoryAccountabilityCompoundSources' } = {}) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCES, fetchType,
        () => Axios.get(`${endPoints.inventory_accountability_compound_sources}`));

// POST confirm which product a prepared item comes from: { compound_din, source_drug_id }
export const SaveInventoryAccountabilityCompoundSource = ({ fetchType = 'inventoryAccountabilityCompoundSourceSave', payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCE_SAVE, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_compound_sources}`, payload));

// POST mark a line as not kept in stock here (or { track_again: true } to undo).
export const MarkInventoryAccountabilityLineNotStocked = ({ fetchType = 'inventoryAccountabilityLineNotStocked', lineId, payload = {} }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_LINE_NOT_STOCKED, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving_lines}/${lineId}/not-stocked`, payload));

// POST manual line match; backend saves a shared item->drug mapping for future invoices: { drug_id }
export const MatchInventoryAccountabilityReceivingLine = ({ fetchType = 'inventoryAccountabilityLineMatch', lineId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_LINE_MATCH, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving_lines}/${lineId}/match`, payload));

// POST verify edited lines of an invoice: { lines: [{ id, qty, lot_number, expiry_date }] }
export const VerifyInventoryAccountabilityReceiving = ({ fetchType = 'inventoryAccountabilityReceivingVerify', reportId, payload }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_VERIFY, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving}/${reportId}/verify`, payload));

// POST matched invoice lines into stock; lot and expiry are optional: { line_ids }
export const PostInventoryAccountabilityReceiving = ({ fetchType = 'inventoryAccountabilityReceivingPost', reportId, payload = {} }) =>
    runInventoryAccountabilityRequest(actionTypes.INVENTORY_ACCOUNTABILITY_RECEIVING_POST, fetchType,
        () => Axios.post(`${endPoints.inventory_accountability_receiving}/${reportId}/post`, payload));

const stateKeys = [
    'addPatientRxDetail',
    'fetchPatientList',
    'pharmacarePatientSearch',
    'pharmacareDeductibleList',
    'pharmacareAddReceivedAmount',
    'pharmacareDeductibleHistory',
    'fetchPatientListV1',
    'fetchRxAccountabilityPdf',
    'updateConsultation',
    'todayProcessedRoutes',
    'prepareCheck',
    'pickupLog',
    'prepCheckPatientPrescription',
    'assignDinLot',
    'prepCheckPrepareAll',
    'pickupSingleRoute',
    'finalCheckLoadPatients',
    'finalCheckRouteList',
    'finalCheckPatientPrescription',
    'todayMissedRxRouteList',
    'todayMissedRxRouteListDetails',
    'afterProcessPrepRouteList',
    'deliveryDriverList',
    'savePatientFlexiDelivery',
    'prepButNotBilled',
    'flexiDeliver',
    'patientPaymentCollectionList',
    'copayDeliveries',
    'billedButNotPrepared',
    'dropActiveRoute',
    'wrongPrep',
    'notBilledPrepWrongCount',
    'drugInformationSheet',
    'getMissedRxData',
    'printLabels',
    'searchPharmacyRx',
    'dailyRoutineTemplate',
    'sharedDailyRoutineAvailability',
    'sharedDailyRoutineTemplates',
    'sharedDailyRoutineTemplate',
    'importSharedDailyRoutineTemplate',
    'lookupDailyRoutineTemplateItem',
    'createDailyRoutineTemplateItem',
    'updateDailyRoutineTemplateItem',
    'deleteDailyRoutineTemplateItem',
    'reorderDailyRoutineTemplateItems',
    'dailyRoutineToday',
    'toggleDailyRoutineRunItem',
    'pharmacyAccountabilityReport',
    'reportRouteList',
    'downloadReport',
    'emergencyReport',
    'downloadEmergencyReport',
    'changeDose',
    'forceDropRoute',
    'notBilledCount',
    'wrongPrepCount',
    'billedButNotPreparedCount',
    'missed3xCount',
    'missed4xCount',
    'muteRx',
    'downloadBulkLabel',
    'oddBilling',
    'patientDrugInformationSheet',
    'downloadPatientDrugInformationSheet',
    'emergencyTodayData',
    'fetchDwiCount',
    'futureChangingDose',
    'weeklyOddBillingSchedule',
    'prepForNewRxRouteList',
    'prepForNewRxRouteData',
    'prepForNewRxCheck',
    'fetchOddScheduleDynamicRx',
    'fetchOtherFrequencyData',
    'fetchDilaudidData',
    'fetchDilaudidSameBid',
    'fetchDilaudidDifferentBid',
    'fetchDilaudidOthers',
    'fetchNonSafeSupplyMissedDoses',
    'updatePacmedTime',
    'fetchRxDosesNotGenerated',
    'fetchDilaudidRxTodayPdf',
    'fetchPreviousDilaudidPdf',
    'fetchDoNotBill',
    'fetchDilaudidFaxToDoctor',
    'fetchArvRx',
    'previewArvRxDataForFax',
    'fetchArvRxFaxList',
    'arvRxFaxViewPdf',
    'fetchRefillsRequest',
    'fetchDrugFamilyList',
    'generateFaxPdf',
    'fetchScheduleRx',
    'fetchDrugFamilyListPatient',
    'fetchDrugFamilyListAnalytics',
    'fetchDrugVisualIntakeMissingDins',
    'saveDrugVisualIntake',
    'missingWitnessCarryRx',
    'fetchNewRxList',
    'fetchNarcoticRxByDate',
    'inventoryAccountabilityDistributors',
    'inventoryAccountabilityDistributorSave',
    'inventoryAccountabilityDistributorDelete',
    'inventoryAccountabilityWinrxComparison',
    'inventoryAccountabilitySetupStatus',
    'inventoryAccountabilitySetupImport',
    'inventoryAccountabilityDashboard',
    'inventoryAccountabilityReports',
    'inventoryAccountabilityReportPdf',
    'inventoryAccountabilityReportCsv',
    'inventoryAccountabilityThreshold',
    'inventoryAccountabilityDrugLots',
    'inventoryAccountabilityLotsAssign',
    'inventoryAccountabilityAdjustmentSave',
    'inventoryAccountabilityReturnsQueue',
    'inventoryAccountabilityReturnRestock',
    'inventoryAccountabilityDestructionList',
    'inventoryAccountabilityDestructionCreate',
    'inventoryAccountabilityDestructionDetail',
    'inventoryAccountabilityDestructionItemAdd',
    'inventoryAccountabilityDestructionItemRemove',
    'inventoryAccountabilityDestructionCancel',
    'inventoryAccountabilityDestructionComplete',
    'inventoryAccountabilityCountSessions',
    'inventoryAccountabilityCountSessionCreate',
    'inventoryAccountabilityCountSessionDetail',
    'inventoryAccountabilityCountSessionLine',
    'inventoryAccountabilityCountSessionSign',
    'inventoryAccountabilityCountSessionCancel',
    'inventoryAccountabilitySupplierReturns',
    'inventoryAccountabilitySupplierReturnCreate',
    'inventoryAccountabilitySupplierReturnShip',
    'inventoryAccountabilitySupplierReturnCredit',
    'inventoryAccountabilityRecalls',
    'inventoryAccountabilityRecallCreate',
    'inventoryAccountabilityRecallDetail',
    'inventoryAccountabilityRecallClose',
    'healthCanadaRecalls',
    'inventoryAccountabilityLotLocation',
    'inventoryAccountabilitySyncStatus',
    'inventoryAccountabilityDrugSearch',
    'inventoryAccountabilityCounts',
    'inventoryAccountabilityDiscrepancyResolve',
    'inventoryAccountabilityReceivingList',
    'inventoryAccountabilityReceivingLines',
    'inventoryAccountabilityReceivingMckessonImport',
    'inventoryAccountabilityReceivingMckessonSave',
    'inventoryAccountabilityCatalogRefresh',
    'inventoryAccountabilityLineMatch',
    'inventoryAccountabilityReceivingVerify',
    'inventoryAccountabilityReceivingPost',
    'inventoryAccountabilityPhysicalCount'
];

const createDefaultState = () => ({
    loading: false,
    error: null,
    data: null,
    fetchType: null,
});

const initialState = stateKeys.reduce((acc, key) => {
    acc[key] = createDefaultState();
    return acc;
}, {});

// Helper function to update state
const updateState = (state, key, updates) => ({
    ...state,
    [key]: { ...state[key], ...updates }
});

// Map action prefixes to state keys
const actionPrefixMap = {
    ADD_PATIENT_RX_DETAIL: 'addPatientRxDetail',
    FETCH_PATIENT_LIST: 'fetchPatientList',
    PHARMACARE_PATIENT_SEARCH: 'pharmacarePatientSearch',
    PHARMACARE_STORE_PAYMENT: 'pharmacareStorePayment',
    PHARMACARE_ADD_RECEIVED_AMOUNT: 'pharmacareAddReceivedAmount',
    PHARMACARE_DEDUCTIBLE_LIST: 'pharmacareDeductibleList',
    PHARMACARE_DEDUCTIBLE_HISTORY: 'pharmacareDeductibleHistory',
    FETCH_RX_ACCOUNTABILITY_PDF: 'fetchRxAccountabilityPdf',
    UPDATE_CONSULTATION: 'updateConsultation',
    TODAY_PROCESSED_ROUTES: 'todayProcessedRoutes',
    PREPARE_CHECK: 'prepareCheck',
    FETCH_PICK_ROUTE_LOGS: 'pickupLog',
    PREP_CHECK_PATIENT_PRESCRIPTION: 'prepCheckPatientPrescription',
    ASSIGN_DIN_LOT: 'assignDinLot',
    PREP_CHECK_PREPARE_ALL: 'prepCheckPrepareAll',
    PICKUP_SINGLE_ROUTE: 'pickupSingleRoute',
    FINAL_CHECK_LOAD_PATIENTS: 'finalCheckLoadPatients',
    FINAL_CHECK_ROUTE_LIST: 'finalCheckRouteList',
    FINAL_CHECK_PATIENT_PRESCRIPTION: 'finalCheckPatientPrescription',
    TODAY_MISSED_RX_ROUTE_LIST: 'todayMissedRxRouteList',
    TODAY_MISSED_RX_ROUTE_LIST_DETAILS: 'todayMissedRxRouteListDetails',
    AFTER_PROCESS_PREP_ROUTE_LIST: 'afterProcessPrepRouteList',
    AFTER_PROCESS_PREP_ROUTE_RX_DATA: 'afterProcessPrepRouteRxData',
    DELIVERY_DRIVER_LIST: 'deliveryDriverList',
    SAVE_PATIENT_FLEXI_DELIVERY: 'savePatientFlexiDelivery',
    PREP_BUT_NOT_BILLED: 'prepButNotBilled',
    FLEXI_DELIVER: 'flexiDeliver',
    PATIENT_PAYMENT_COLLECTION_LIST: 'patientPaymentCollectionList',
    COPAY_DELIVERIES: 'copayDeliveries',
    BILLED_BUT_NOT_PREPARED: 'billedButNotPrepared',
    DROP_ACTIVE_ROUTE: 'dropActiveRoute',
    WRONG_PREP: 'wrongPrep',
    NOT_BILLED_PREP_WRONG_COUNT: 'notBilledPrepWrongCount',
    DRUG_INFORMATION_SHEET: 'drugInformationSheet',
    GET_MISSED_RX_DATA: 'getMissedRxData',
    PRINT_LABELS: 'printLabels',
    SEARCH_PHARMACY_RX: 'searchPharmacyRx',
    FETCH_DAILY_ROUTINE_TEMPLATE: 'dailyRoutineTemplate',
    FETCH_SHARED_DAILY_ROUTINE_AVAILABILITY: 'sharedDailyRoutineAvailability',
    FETCH_SHARED_DAILY_ROUTINE_TEMPLATES: 'sharedDailyRoutineTemplates',
    FETCH_SHARED_DAILY_ROUTINE_TEMPLATE: 'sharedDailyRoutineTemplate',
    IMPORT_SHARED_DAILY_ROUTINE_TEMPLATE: 'importSharedDailyRoutineTemplate',
    LOOKUP_DAILY_ROUTINE_TEMPLATE_ITEM: 'lookupDailyRoutineTemplateItem',
    CREATE_DAILY_ROUTINE_TEMPLATE_ITEM: 'createDailyRoutineTemplateItem',
    UPDATE_DAILY_ROUTINE_TEMPLATE_ITEM: 'updateDailyRoutineTemplateItem',
    DELETE_DAILY_ROUTINE_TEMPLATE_ITEM: 'deleteDailyRoutineTemplateItem',
    REORDER_DAILY_ROUTINE_TEMPLATE_ITEMS: 'reorderDailyRoutineTemplateItems',
    FETCH_DAILY_ROUTINE_TODAY: 'dailyRoutineToday',
    TOGGLE_DAILY_ROUTINE_RUN_ITEM: 'toggleDailyRoutineRunItem',
    PHARMACY_ACCOUNTABILITY_REPORT: 'pharmacyAccountabilityReport',
    REPORT_ROUTE_LIST: 'reportRouteList',
    DOWNLOAD_REPORT: 'downloadReport',
    EMERGENCY_REPORT: 'emergencyReport',
    DOWNLOAD_EMERGENCY_REPORT: 'downloadEmergencyReport',
    CHANGE_DOSE: 'changeDose',
    FORCE_DROP_ROUTE: 'forceDropRoute',
    NOT_BILLED_COUNT: 'notBilledCount',
    WRONG_PREP_COUNT: 'wrongPrepCount',
    BILLED_BUT_NOT_PREPARED_COUNT: 'billedButNotPreparedCount',
    MISSED_3X_COUNT: 'missed3xCount',
    MISSED_4X_COUNT: 'missed4xCount',
    MUTE_RX: 'muteRx',
    DOWNLOAD_BULK_LABEL: 'downloadBulkLabel',
    ODD_BILLING: 'oddBilling',
    PATIENT_DRUG_INFORMATION_SHEET: 'patientDrugInformationSheet',
    DOWNLOAD_PATIENT_DRUG_INFORMATION_SHEET: 'downloadPatientDrugInformationSheet',
    EMERGENCY_TODAY_DATA: 'emergencyTodayData',
    FETCH_DWI_COUNT: 'fetchDwiCount',
    FUTURE_CHANGING_DOSE: 'futureChangingDose',
    WEEKLY_ODD_BILLING_SCHEDULE: 'weeklyOddBillingSchedule',
    PREP_FOR_NEW_RX_ROUTE_LIST: 'prepForNewRxRouteList',
    PREP_FOR_NEW_RX_ROUTE_DATA: 'prepForNewRxRouteData',
    PREP_FOR_NEW_RX_CHECK: 'prepForNewRxCheck',
    FETCH_ODD_SCHEDULE_DYNAMIC_RX: 'fetchOddScheduleDynamicRx',
    FETCH_OTHER_FREQUENCY_DATA: 'fetchOtherFrequencyData',
    FETCH_DILAUDID_DATA: 'fetchDilaudidData',
    FETCH_DILAUDID_SAME_BID: 'fetchDilaudidSameBid',
    FETCH_DILAUDID_DIFFERENT_BID: 'fetchDilaudidDifferentBid',
    FETCH_DILAUDID_OTHERS: 'fetchDilaudidOthers',
    FETCH_NON_SAFE_SUPPLY_MISSED_DOSES: 'fetchNonSafeSupplyMissedDoses',
    UPDATE_PACMED_TIME: 'updatePacmedTime',
    FETCH_RX_DOSES_NOT_GENERATED: 'fetchRxDosesNotGenerated',
    FETCH_DILAUDID_RX_TODAY_PDF: 'fetchDilaudidRxTodayPdf',
    FETCH_PREVIOUS_DILAUDID_PDF: 'fetchPreviousDilaudidPdf',
    FETCH_DO_NOT_BILL: 'fetchDoNotBill',
    FETCH_DILAUDID_FAX_TO_DOCTOR: 'fetchDilaudidFaxToDoctor',
    FETCH_ARV_RX: 'fetchArvRx',
    PREVIEW_ARV_RX_DATA_FOR_FAX: 'previewArvRxDataForFax',
    FETCH_ARV_RX_FAX_LIST: 'fetchArvRxFaxList',
    ARV_RX_FAX_VIEW_PDF: 'arvRxFaxViewPdf',
    FETCH_REFILLS_REQUEST: 'fetchRefillsRequest',
    FETCH_DRUG_FAMILY_LIST: 'fetchDrugFamilyList',
    FETCH_DRUG_FAMILY_LIST_PATIENT: 'fetchDrugFamilyListPatient',
    FETCH_DRUG_FAMILY_LIST_ANALYTICS: 'fetchDrugFamilyListAnalytics',
    FETCH_SCHEDULE_RX: 'fetchScheduleRx',
    FETCH_PATIENT_LIST_V1: 'fetchPatientListV1',
    GENERATE_FAX_PDF: 'generateFaxPdf',
    FETCH_DRUG_VISUAL_INTAKE_MISSING_DINS: 'fetchDrugVisualIntakeMissingDins',
    SAVE_DRUG_VISUAL_INTAKE: 'saveDrugVisualIntake',
    MISSING_WITNESS_CARRY_RX: 'missingWitnessCarryRx',
    FETCH_NEW_RX_LIST: 'fetchNewRxList',
    FETCH_NARCOTIC_RX_BY_DATE: 'fetchNarcoticRxByDate',
    INVENTORY_ACCOUNTABILITY_DISTRIBUTORS: 'inventoryAccountabilityDistributors',
    INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_SAVE: 'inventoryAccountabilityDistributorSave',
    INVENTORY_ACCOUNTABILITY_DISTRIBUTOR_DELETE: 'inventoryAccountabilityDistributorDelete',
    INVENTORY_ACCOUNTABILITY_WINRX_COMPARISON: 'inventoryAccountabilityWinrxComparison',
    INVENTORY_ACCOUNTABILITY_SETUP_STATUS: 'inventoryAccountabilitySetupStatus',
    INVENTORY_ACCOUNTABILITY_SETUP_IMPORT: 'inventoryAccountabilitySetupImport',
    INVENTORY_ACCOUNTABILITY_DASHBOARD: 'inventoryAccountabilityDashboard',
    INVENTORY_ACCOUNTABILITY_DOSE_DETAILS: 'inventoryAccountabilityDoseDetails',
    INVENTORY_ACCOUNTABILITY_DRUG_MOVEMENTS: 'inventoryAccountabilityDrugMovements',
    INVENTORY_ACCOUNTABILITY_REPORTS: 'inventoryAccountabilityReports',
    INVENTORY_ACCOUNTABILITY_REPORT_PDF: 'inventoryAccountabilityReportPdf',
    INVENTORY_ACCOUNTABILITY_REPORT_CSV: 'inventoryAccountabilityReportCsv',
    INVENTORY_ACCOUNTABILITY_THRESHOLD: 'inventoryAccountabilityThreshold',
    INVENTORY_ACCOUNTABILITY_DRUG_LOTS: 'inventoryAccountabilityDrugLots',
    INVENTORY_ACCOUNTABILITY_LOTS_ASSIGN: 'inventoryAccountabilityLotsAssign',
    INVENTORY_ACCOUNTABILITY_ADJUSTMENT_SAVE: 'inventoryAccountabilityAdjustmentSave',
    INVENTORY_ACCOUNTABILITY_RETURNS_QUEUE: 'inventoryAccountabilityReturnsQueue',
    INVENTORY_ACCOUNTABILITY_RETURN_RESTOCK: 'inventoryAccountabilityReturnRestock',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_LIST: 'inventoryAccountabilityDestructionList',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_CREATE: 'inventoryAccountabilityDestructionCreate',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_DETAIL: 'inventoryAccountabilityDestructionDetail',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_ADD: 'inventoryAccountabilityDestructionItemAdd',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_ITEM_REMOVE: 'inventoryAccountabilityDestructionItemRemove',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_CANCEL: 'inventoryAccountabilityDestructionCancel',
    INVENTORY_ACCOUNTABILITY_DESTRUCTION_COMPLETE: 'inventoryAccountabilityDestructionComplete',
    INVENTORY_ACCOUNTABILITY_COUNT_SESSIONS: 'inventoryAccountabilityCountSessions',
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CREATE: 'inventoryAccountabilityCountSessionCreate',
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_DETAIL: 'inventoryAccountabilityCountSessionDetail',
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_LINE: 'inventoryAccountabilityCountSessionLine',
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_SIGN: 'inventoryAccountabilityCountSessionSign',
    INVENTORY_ACCOUNTABILITY_COUNT_SESSION_CANCEL: 'inventoryAccountabilityCountSessionCancel',
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURNS: 'inventoryAccountabilitySupplierReturns',
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREATE: 'inventoryAccountabilitySupplierReturnCreate',
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_SHIP: 'inventoryAccountabilitySupplierReturnShip',
    INVENTORY_ACCOUNTABILITY_SUPPLIER_RETURN_CREDIT: 'inventoryAccountabilitySupplierReturnCredit',
    INVENTORY_ACCOUNTABILITY_RECALLS: 'inventoryAccountabilityRecalls',
    INVENTORY_ACCOUNTABILITY_RECALL_CREATE: 'inventoryAccountabilityRecallCreate',
    INVENTORY_ACCOUNTABILITY_RECALL_DETAIL: 'inventoryAccountabilityRecallDetail',
    INVENTORY_ACCOUNTABILITY_RECALL_CLOSE: 'inventoryAccountabilityRecallClose',
    HEALTH_CANADA_RECALLS: 'healthCanadaRecalls',
    INVENTORY_ACCOUNTABILITY_LOT_LOCATION: 'inventoryAccountabilityLotLocation',
    INVENTORY_ACCOUNTABILITY_SYNC_STATUS: 'inventoryAccountabilitySyncStatus',
    INVENTORY_ACCOUNTABILITY_DRUG_SEARCH: 'inventoryAccountabilityDrugSearch',
    INVENTORY_ACCOUNTABILITY_COUNTS: 'inventoryAccountabilityCounts',
    INVENTORY_ACCOUNTABILITY_DISCREPANCY_RESOLVE: 'inventoryAccountabilityDiscrepancyResolve',
    INVENTORY_ACCOUNTABILITY_RECEIVING_LIST: 'inventoryAccountabilityReceivingList',
    INVENTORY_ACCOUNTABILITY_RECEIVING_LINES: 'inventoryAccountabilityReceivingLines',
    INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT: 'inventoryAccountabilityReceivingMckessonImport',
    INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_IMPORT_STATUS: 'inventoryAccountabilityReceivingMckessonImportStatus',
    INVENTORY_ACCOUNTABILITY_RECEIVING_MCKESSON_SAVE: 'inventoryAccountabilityReceivingMckessonSave',
    INVENTORY_ACCOUNTABILITY_CATALOG_REFRESH: 'inventoryAccountabilityCatalogRefresh',
    INVENTORY_ACCOUNTABILITY_CATALOG_STATUS: 'inventoryAccountabilityCatalogStatus',
    INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCES: 'inventoryAccountabilityCompoundSources',
    INVENTORY_ACCOUNTABILITY_COMPOUND_SOURCE_SAVE: 'inventoryAccountabilityCompoundSourceSave',
    INVENTORY_ACCOUNTABILITY_LINE_MATCH: 'inventoryAccountabilityLineMatch',
    INVENTORY_ACCOUNTABILITY_LINE_NOT_STOCKED: 'inventoryAccountabilityLineNotStocked',
    INVENTORY_ACCOUNTABILITY_RECEIVING_VERIFY: 'inventoryAccountabilityReceivingVerify',
    INVENTORY_ACCOUNTABILITY_RECEIVING_POST: 'inventoryAccountabilityReceivingPost',
    INVENTORY_ACCOUNTABILITY_PHYSICAL_COUNT: 'inventoryAccountabilityPhysicalCount',
    FETCH_DRUG_QUANTITY_BY_DATE: 'fetchDrugQuantityByDate'
};

// Helper function to get updates based on action status
const getStatusUpdates = (status, payload) => ({
    REQUEST: { loading: true, data: null, error: null, fetchType: payload.requestType },
    SUCCESS: { loading: false, error: null, data: payload.data, fetchType: payload.requestType },
    FAILURE: { loading: false, error: payload.error, data: null, fetchType: payload.requestType }
}[status]);

// Reducer
const AccountabilityNewRxReducer = (state = initialState, { type, payload }) => {
    const typeParts = type.split('_');
    const status = typeParts.pop();
    const prefix = typeParts.join('_');
    const key = actionPrefixMap[prefix];

    if (!key) return state;

    let updates = getStatusUpdates(status, payload);
    // Scroll pagination: preserve list on REQUEST when appending
    if (key === 'pharmacareDeductibleList' && status === 'REQUEST' && payload?.append && state[key]?.data) {
        updates = { loading: true, error: null, fetchType: payload.requestType };
    }
    // Append list/summary for scroll pagination (Pharmacare deductible list)
    if (key === 'pharmacareDeductibleList' && status === 'SUCCESS' && payload?.append && state[key]?.data) {
        const prev = state[key].data;
        const next = payload.data || {};
        const mergedList = Array.isArray(prev.list) && Array.isArray(next.list)
            ? [...prev.list, ...next.list] : (next.list ?? prev.list);
        const mergedSummary = Array.isArray(prev.summary) && Array.isArray(next.summary)
            ? [...prev.summary, ...next.summary] : (next.summary ?? prev.summary);
        updates = {
            ...updates,
            data: {
                ...next,
                list: mergedList,
                summary: mergedSummary,
            },
        };
    }
    return updates ? updateState(state, key, updates) : state;
};

export default AccountabilityNewRxReducer;
